export const translations: Record<'en' | 'id', Record<string, string>> = {
  en: {
    // Simple keys
    'dashboard': 'Dashboard',
    'tasks': 'Tasks',
    'weeklyMenu': 'Weekly Menu Planner',
    'addMeal': 'Add Meal',
    'todaysExpenses': "Today's Expenses",
    'totalSpent': 'total spent',
    'selfCare': 'Self-Care',
    'trackWellness': 'Track your wellness',
    'shop': 'Shop',
    'createShop': 'Create My Shop',
    'shopName': 'Shop Name',
    'description': 'Description',
    'category': 'Category',
    'uploadLogo': 'Upload logo',
    'searchProducts': 'Search products...',
    
    // Menu Planner
    'menu.title': 'Weekly Menu Planner',
    'menu.subtitle': 'Plan your meals and simplify grocery shopping',
    'menu.planner': 'Menu Planner',
    'menu.addMeal': 'Add Meal',
    'menu.addNewMeal': 'Add New Meal',
    'menu.mealName': 'Meal Name',
    'menu.dayOfWeek': 'Day of Week',
    'menu.mealType': 'Meal Type',
    'menu.ingredients': 'Ingredients (comma separated)',
    'menu.ingredientsPlaceholder': 'Rice, Chicken, Vegetables',
    'menu.breakfast': 'Breakfast',
    'menu.lunch': 'Lunch',
    'menu.dinner': 'Dinner',
    'menu.snack': 'Snack',
    'menu.selectType': 'Select type',
    'menu.monday': 'Monday',
    'menu.tuesday': 'Tuesday',
    'menu.wednesday': 'Wednesday',
    'menu.thursday': 'Thursday',
    'menu.friday': 'Friday',
    'menu.saturday': 'Saturday',
    'menu.sunday': 'Sunday',
    
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.tasks': 'Tasks',
    'nav.dailyRoutine': 'Daily Routine',
    'nav.menu': 'Menu Planner',
    'nav.finance': 'Expense Tracker',
    'nav.selfcare': 'Self-Care',
    'nav.community': 'Community',
    'nav.marketplace': 'Marketplace',
    'nav.business': 'Business Hub',
    'nav.journal': 'Journal',
    'nav.movement': 'Movement',
    'nav.cart': 'Cart',
    'nav.signin': 'Sign In',
    'nav.signout': 'Sign Out',
    
    // Movement
    'movement.title': 'Movement',
    'movement.subtitle': 'Move in a way that feels good',
    'movement.emptyTitle': 'Move in a way that feels good today.',
    'movement.emptySubtitle': 'No rules. No pressure.',
    'movement.add': 'Add Movement',
    'movement.addTitle': 'Add Movement',
    'movement.activityName': 'Activity name',
    'movement.activityPlaceholder': 'e.g. Walking, Stretching',
    'movement.goal': 'Goal (optional)',
    'movement.goalPlaceholder': 'e.g. 20 minutes',
    'movement.goalLabel': 'Goal',
    'movement.duration': 'Duration (optional)',
    'movement.durationPlaceholder': 'Minutes',
    'movement.date': 'Date',
    'movement.notes': 'Notes (optional)',
    'movement.notesPlaceholder': 'How did it feel?',
    'movement.save': 'Save',
    'movement.saved': 'Movement saved!',
    'movement.minutes': 'minutes',
    
    // Auth
    'auth.title': 'Welcome to TechMom',
    'auth.subtitle': 'Your all-in-one platform for modern moms',
    'auth.signin': 'Sign In',
    'auth.signup': 'Sign Up',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.fullname': 'Full Name',
    'auth.forgotpassword': 'Forgot password?',
    'auth.noaccount': "Don't have an account?",
    'auth.haveaccount': 'Already have an account?',
    'auth.signinhere': 'Sign in',
    'auth.signuphere': 'Sign up',
    'auth.loading': 'Please wait...',
    'auth.welcomeback': 'Welcome back!',
    'auth.createaccount': 'Create your account',
    'auth.accountcreated': 'Account created! Please check your email.',
    'auth.alreadyregistered': 'This email is already registered. Please sign in instead.',
    
    // Marketplace
    'marketplace.title': 'TechMom Marketplace',
    'marketplace.subtitle': 'Shop from amazing mom entrepreneurs',
    'marketplace.search': 'Search products...',
    'marketplace.categories': 'Shop by Category',
    'marketplace.featured': 'Featured Shops',
    'marketplace.products': 'All Products',
    'marketplace.addtocart': 'Add to Cart',
    'marketplace.createShop': 'Create My Shop',
    'marketplace.mommade': 'Mom-made',
    'marketplace.clothing': 'Clothing',
    'marketplace.food': 'Food',
    'marketplace.digital': 'Digital Products',
    'marketplace.baby': 'Baby & Kids',
    'marketplace.crafts': 'Arts & Crafts',
    'marketplace.books': 'Books',
    'marketplace.gifts': 'Gifts',
    'marketplace.home': 'Home & Living',
    'marketplace.beauty': 'Beauty',
    'marketplace.new': 'New',
    'marketplace.clearFilter': 'Clear filter',
    'marketplace.sortNewest': 'Newest first',
    'marketplace.sortOldest': 'Oldest first',
    'marketplace.sortPriceLow': 'Price: Low to High',
    'marketplace.sortPriceHigh': 'Price: High to Low',
    'marketplace.sortNameAZ': 'Name: A to Z',
    'marketplace.sortNameZA': 'Name: Z to A',
    
    // Community
    'community.title': 'Community',
    'community.shareWith': 'Share with the community',
    'community.whatsOnMind': "What's on your mind?",
    'community.charactersRemaining': 'characters remaining',
    'community.category': 'Category',
    'community.post': 'Post',
    'community.likes': 'Likes',
    'community.comment': 'Comment',
    'community.anonymous': 'Anonymous',
    'community.parenting': 'Parenting',
    'community.cooking': 'Cooking',
    'community.businessMoms': 'Business Moms',
    'community.selfCare': 'Self-Care',
    'community.general': 'General',
    'community.postCreated': 'Post created!',
    'community.errorCreating': 'Error creating post',
    'community.loginToPost': 'Please log in to post',
    'community.loginToLike': 'Please log in to like posts',
    'community.errorLike': 'Error updating like',
    
    // Product
    'product.soldby': 'Sold by',
    'product.size': 'Size',
    'product.color': 'Color',
    'product.quantity': 'Quantity',
    'product.addtocart': 'Add to Cart',
    'product.buynow': 'Buy Now',
    'product.shipping': 'Shipping',
    'product.returns': 'Returns',
    'product.description': 'Product Description',
    'product.instock': 'In Stock',
    'product.outofstock': 'Out of Stock',
    'product.reviews': 'Reviews',
    'product.writeReview': 'Write a Review',
    'product.editReview': 'Edit Review',
    'product.yourRating': 'Your Rating',
    'product.yourReview': 'Your Review (optional)',
    'product.reviewPlaceholder': 'Share your thoughts about this product...',
    'product.noReviews': 'No reviews yet. Be the first to review!',
    'product.addedToWishlist': 'Added to wishlist',
    'product.removedFromWishlist': 'Removed from wishlist',
    
    // Cart
    'cart.title': 'Shopping Cart',
    'cart.empty': 'Your cart is empty',
    'cart.emptyDesc': 'Start adding some products to your cart!',
    'cart.browse': 'Browse Products',
    'cart.remove': 'Remove',
    'cart.removed': 'Item removed from cart',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.shippingCalc': 'Calculated at checkout',
    'cart.total': 'Total',
    'cart.checkout': 'Proceed to Checkout',
    'cart.continue': 'Continue Shopping',
    'cart.free': 'Free',
    'cart.loginCheckout': 'Please login to checkout',
    'cart.orderSummary': 'Order Summary',
    
    // Checkout
    'checkout.title': 'Checkout',
    'checkout.shipping': 'Shipping Information',
    'checkout.address': 'Shipping Address',
    'checkout.addressPlaceholder': 'Enter your complete shipping address',
    'checkout.payment': 'Payment Method',
    'checkout.sandboxMode': 'Sandbox Mode:',
    'checkout.testPayment': 'Use test payment methods below',
    'checkout.sandboxCard': 'Sandbox Credit Card',
    'checkout.testCard': 'Test card payment',
    'checkout.sandboxWallet': 'Sandbox E-Wallet',
    'checkout.testWallet': 'Test digital wallet',
    'checkout.cod': 'Cash on Delivery',
    'checkout.codDesc': 'Pay when you receive',
    'checkout.cardNumber': 'Card Number',
    'checkout.walletId': 'Wallet ID',
    'checkout.testValue': 'Any test value will work in sandbox mode',
    'checkout.placeorder': 'Place Order',
    'checkout.processing': 'Processing...',
    'checkout.summary': 'Order Summary',
    'checkout.confirmed': 'Order Confirmed!',
    'checkout.thankyou': 'Thank you for your purchase. Your order has been placed successfully.',
    'checkout.reference': 'Payment Reference:',
    'checkout.saveRef': 'Save this reference for your records. This is a sandbox payment.',
    'checkout.continueshop': 'Continue Shopping',
    'checkout.gotodash': 'Go to Dashboard',
    'checkout.enterAddress': 'Please enter a shipping address',
    'checkout.enterCard': 'Please enter card/wallet details',
    'checkout.processingPayment': 'Processing sandbox payment...',
    'checkout.paymentSuccess': 'Payment successful!',
    'checkout.orderSuccess': 'Order placed successfully!',
    'checkout.orderError': 'Error placing order',
    'checkout.emailSent': 'Order confirmation email sent!',
    'checkout.emailFailed': 'Order placed but email failed to send',
    
    // Dashboard
    'dashboard.greeting.morning': 'Good Morning',
    'dashboard.greeting.afternoon': 'Good Afternoon',
    'dashboard.greeting.evening': 'Good Evening',
    'dashboard.lets_make_today': "Let's make today amazing!",
    'dashboard.tasks_due_today': 'Tasks Due Today',
    'dashboard.pending_items': 'pending items',
    'dashboard.todays_expenses': "Today's Expenses",
    'dashboard.total_spent': 'total spent',
    'dashboard.create_my_shop': 'Create My Shop',
    'dashboard.shop_by_category': 'Shop by Category',
    'dashboard.food': 'Food',
    'dashboard.digital_products': 'Digital Products',
    'dashboard.clothing': 'Clothing',
    'dashboard.mom_made': 'Mom-made',
    'dashboard.search_products': 'Search products...',
    'dashboard.menu_planner': 'Menu Planner',
    'dashboard.plan_meals': 'Plan your meals',
    'dashboard.weekly_schedule': 'weekly schedule',
    'dashboard.self_care': 'Self-Care',
    'dashboard.track_wellness': 'Track your wellness',
    'dashboard.daily_goals': 'daily goals',
    'dashboard.quick_actions': 'Quick Actions',
    'dashboard.add_task': 'Add Task',
    'dashboard.add_expense': 'Add Expense',
    'dashboard.add_meal': 'Add Meal',
    'dashboard.techmom_tip': 'TechMom Tip of the Day',
    'dashboard.tip_content': 'Start your day by setting your top 3 priorities. Everything else can wait!',
    
    // Finance
    'finance.title': 'Finance Tracker',
    'finance.subtitle': 'Keep track of your expenses and budget',
    'finance.expenses': 'Expenses',
    'finance.income': 'Income',
    'finance.savings': 'Savings',
    'finance.balance': 'Balance',
    'finance.balanceHelper': 'Total balance from your wallet(s)',
    'finance.totalRecorded': 'Total recorded',
    'finance.savedSoFar': 'Saved so far',
    'finance.lifetimeTotal': 'Lifetime total',
    'finance.periodTotal': 'This period',
    'finance.netChange': 'Net',
    
    // Period Filter
    'finance.period.viewing': 'Viewing',
    'finance.period.today': 'Today',
    'finance.period.thisMonth': 'This Month',
    'finance.period.lastMonth': 'Last Month',
    'finance.period.thisYear': 'This Year',
    'finance.period.custom': 'Custom Range',
    'finance.period.selectCustomRange': 'Or select custom range',
    'finance.period.comparison': 'vs Previous Period',
    'finance.period.noPreviousData': 'No data from previous period to compare',
    'finance.wallets': 'Wallets',
    'finance.addWallet': 'Add Wallet',
    'finance.editWallet': 'Edit Wallet',
    'finance.walletName': 'Wallet Name',
    'finance.startingBalance': 'Starting Balance',
    'finance.selectWallet': 'Select Wallet',
    'finance.noWallets': 'No wallet yet',
    'finance.noWalletHint': 'Your wallet will be created automatically.',
    'finance.totalWalletBalance': 'Total Wallet Balance',
    'finance.walletBalance': 'Balance',
    'finance.defaultWallet': 'Default',
    'finance.setAsDefault': 'Set as default',
    'finance.transferMoney': 'Transfer Money',
    'finance.transferBetweenWallets': 'Transfer Between Wallets',
    'finance.fromWallet': 'From Wallet',
    'finance.toWallet': 'To Wallet',
    'finance.transferAmount': 'Transfer Amount',
    'finance.transfer': 'Transfer',
    'finance.selectSourceWallet': 'Select source wallet',
    'finance.selectDestWallet': 'Select destination wallet',
    'finance.transferSuccess': 'Transfer completed successfully',
    'finance.transferError': 'Error completing transfer',
    'finance.sameWalletError': 'Source and destination cannot be the same',
    'finance.walletBalanceHistory': 'Wallet Balance History',
    'finance.filterByWallet': 'Filter by Wallet',
    'finance.allWallets': 'All Wallets',
    'finance.noWallet': 'No Wallet',
    'finance.walletDetails': 'Wallet Details',
    'finance.addIncomeToWallet': 'Add Income',
    'finance.addExpenseFromWallet': 'Add Expense',
    'finance.transferFromWallet': 'Transfer',
    'finance.manageWallet': 'Manage Wallet',
    'finance.addExpense': 'Add Expense',
    'finance.addIncome': 'Add Income',
    'finance.addSaving': 'Add Saving',
    'finance.addNew': 'Add New',
    'finance.editTransaction': 'Edit Transaction',
    'finance.type': 'Type',
    'finance.amount': 'Amount (IDR)',
    'finance.date': 'Date',
    'finance.paymentMethod': 'Payment Method',
    'finance.notes': 'Notes',
    'finance.all': 'All',
    'finance.budget': 'Budget Goals',
    'finance.setBudget': 'Set Budget',
    'finance.budgetFor': 'Budget for',
    'finance.spent': 'spent',
    'finance.remaining': 'remaining',
    'finance.overBudget': 'over budget',
    'finance.recurring': 'Recurring Transactions',
    'finance.recurringHelper': 'Automatically adds transactions on schedule.',
    'finance.addRecurring': 'Add Recurring',
    'finance.frequency': 'Frequency',
    'finance.daily': 'Daily',
    'finance.weekly': 'Weekly',
    'finance.monthly': 'Monthly',
    'finance.yearly': 'Yearly',
    'finance.startDate': 'Start Date',
    'finance.nextRun': 'Next run',
    'finance.active': 'Active',
    'finance.paused': 'Paused',
    'finance.overview': 'Overview',
    'finance.transactions': 'Transactions',
    'finance.budgets': 'Budgets',
    'finance.savingsGoals': 'Savings Goals',
    'finance.thisMonth': 'This Month',
    'finance.noTransactions': 'No transactions yet',
    'finance.addFirst': 'Add your first transaction',
    'finance.category': 'Category',
    'finance.search': 'Search transactions...',
    'finance.export': 'Export PDF',
    'finance.selectCategory': 'Select category',
    'finance.monthlyReport': 'Monthly Report',
    'finance.financeReport': 'Finance Report',
    'finance.spendingByCategory': 'Spending by Category',
    'finance.topSpending': 'Top Spending',
    'finance.budgetPerformance': 'Budget Performance',
    'finance.vsLastMonth': 'vs last month',
    'finance.manageCategories': 'Manage Categories',
    'finance.addCategory': 'Add Category',
    'finance.categoryName': 'Category Name',
    'finance.chooseEmoji': 'Choose Emoji',
    'finance.chooseColor': 'Choose Color',
    'finance.customCategories': 'Custom Categories',
    'finance.noBudgets': 'No budget goals set',
    'finance.setFirstBudget': 'Set your first budget to track spending',
    'finance.addFromTemplate': 'Add from Template',
    'finance.lastMonth': 'Last Month',
    'finance.last30Days': 'Last 30 Days',
    'finance.thisYear': 'This Year',
    'finance.clearFilter': 'Clear Filter',
    'finance.totalBalance': 'Total Balance',
    'finance.totalIncome': 'Total Income',
    'finance.totalExpenses': 'Total Expenses',
    'finance.totalSavings': 'Total Savings',
    'finance.savingsProgress': 'Savings Progress',
    'finance.addSavingsGoal': 'Add Savings Goal',
    'finance.goalTitle': 'Goal Title',
    'finance.targetAmount': 'Target Amount',
    'finance.currentAmount': 'Current Amount',
    'finance.deadline': 'Deadline',
    'finance.addMoney': 'Add Money',
    'finance.recurringTitle': 'Title',
    'finance.copyLastMonth': 'Copy Last Month',
    'finance.saveAsTemplate': 'Save as Template',
    'finance.templateName': 'Template Name',
    'finance.templateDescription': 'Description',
    'finance.applyTemplate': 'Apply Template',
    'finance.deleteTemplate': 'Delete Template',
    'finance.budgetTemplates': 'Budget Templates',
    'finance.customTemplates': 'Custom Templates',
    'finance.basicLiving': 'Basic Living',
    'finance.familyBudget': 'Family Budget',
    'finance.studentLife': 'Student Life',
    'finance.workingPro': 'Working Professional',
    'finance.savingsFocused': 'Savings Focused',
    'finance.receipts': 'Receipts',
    'finance.addReceipt': 'Add Receipt',
    'finance.attachReceipt': 'Attach Receipt (optional)',
    'finance.transactionUpdated': 'Transaction updated',
    'finance.addNotes': 'Add notes...',
    
    // Expense logging (AI Assistant wallet integration)
    'expense.logExpense': 'Log Expense',
    'expense.confirmDetails': 'Confirm expense details before saving',
    'expense.wallet': 'Wallet',
    'expense.loadingWallets': 'Loading wallets...',
    'expense.noWallets': 'No wallets found. Create one in Expense Tracker.',
    'expense.selectWallet': 'Select wallet',
    'expense.noWalletOption': 'No wallet',
    'expense.currentBalance': 'Current balance:',
    'expense.deduction': 'Expense:',
    'expense.newBalance': 'New balance:',
    'expense.negativeWarning': 'Balance will become negative',
    'expense.confirmAndSave': 'Confirm & Save',
    
    // Finance categories
    'finance.cat.food': 'Food',
    'finance.cat.groceries': 'Groceries',
    'finance.cat.transport': 'Transport',
    'finance.cat.shopping': 'Shopping',
    'finance.cat.bills': 'Bills',
    'finance.cat.utilities': 'Utilities',
    'finance.cat.entertainment': 'Entertainment',
    'finance.cat.healthcare': 'Healthcare',
    'finance.cat.education': 'Education',
    'finance.cat.subscriptions': 'Subscriptions',
    'finance.cat.travel': 'Travel',
    'finance.cat.salary': 'Salary',
    'finance.cat.investment': 'Investment',
    'finance.cat.other': 'Other',
    // Payment methods
    'finance.pay.cash': 'Cash',
    'finance.pay.debit': 'Debit Card',
    'finance.pay.credit': 'Credit Card',
    'finance.pay.transfer': 'Bank Transfer',
    'finance.pay.ewallet': 'E-Wallet',
    'finance.pay.qris': 'QRIS',
    // Finance - Quick Add & Settings
    'finance.quickAddExpense': 'Quick Add Expense',
    'finance.customize': 'Customize',
    'finance.showHide': 'Show / Hide',
    'finance.customQuickExpenses': 'Custom Quick Expenses',
    'finance.addNewQuickExpense': 'Add New Quick Expense',
    'finance.yourCustomQuickExpenses': 'Your Custom Quick Expenses',
    'finance.noCustomQuickExpenses': 'No custom quick expenses yet. Add your frequently used expenses above!',
    'finance.addQuickExpense': 'Add Quick Expense',
    'finance.label': 'Label',
    'finance.incomeVsExpenses': 'Income vs Expenses',
    'finance.currencySettings': 'Currency Settings',
    'finance.defaultCurrency': 'Default Currency',
    'finance.showCurrencyConversion': 'Show Currency Conversion',
    'finance.displayConvertedAmounts': 'Display converted amounts',
    'finance.convertTo': 'Convert to',
    'finance.settings': 'Settings',
    'finance.enableQuickAdd': 'Enable Quick Add',
    'finance.quickAddDescription': 'This feature is optional. Turning it off will simplify your finance page without affecting your data.',
    'finance.on': 'On',
    'finance.off': 'Off',
    'finance.generateReport': 'Generate Report',
    'finance.downloadPdf': 'Download PDF',
    'finance.shareReport': 'Share Report',
    'finance.history': 'History',
    'finance.todaySummary': "Today's Summary",
    'finance.incomeToday': 'Income Today',
    'finance.expensesToday': 'Expenses Today',
    'finance.netToday': 'Net Today',
    
    // Monthly Bills
    'finance.bills': 'Bills',
    'finance.monthlyBills': 'Monthly Bill Checklist',
    'finance.addBill': 'Add Bill',
    'finance.editBill': 'Edit Bill',
    'finance.billName': 'Bill Name',
    'finance.monthlyAmount': 'Monthly Amount',
    'finance.dueDate': 'Due Date',
    'finance.optional': 'optional',
    'finance.selectDueDate': 'Select due date',
    'finance.totalAnnual': 'Annual Total',
    'finance.totalPaid': 'Total Paid',
    'finance.totalUnpaid': 'Unpaid',
    'finance.overallProgress': 'Overall Progress',
    'finance.categoryBreakdown': 'Spending by Category',
    'finance.noBills': 'No bills yet',
    'finance.noBillsHint': 'Track your recurring monthly bills like school fees, subscriptions, and utilities',
    'finance.addFirstBill': 'Add Your First Bill',
    'finance.monthsPaid': 'months paid',
    'finance.monthsLeft': 'left',
    'finance.noFilteredBills': 'No bills in this category',
    'finance.noFilteredBillsHint': 'Try selecting a different category or add a new bill',
    'finance.showAllBills': 'Show All Bills',
    
    // Personal Loans
    'finance.loans': 'Loans',
    'finance.loans.title': 'Personal Loans',
    'finance.loans.addLoan': 'Add Loan',
    'finance.loans.editLoan': 'Edit Loan',
    'finance.loans.loanName': 'Loan Name',
    'finance.loans.loanNamePlaceholder': 'e.g., Car Loan, Home Improvement',
    'finance.loans.totalAmount': 'Total Amount',
    'finance.loans.remaining': 'Remaining',
    'finance.loans.monthlyPayment': 'Monthly Payment',
    'finance.loans.dueDay': 'Due Day (1-31)',
    'finance.loans.status': 'Status',
    'finance.loans.active': 'Active',
    'finance.loans.paidOff': 'Paid Off',
    'finance.loans.notes': 'Notes (optional)',
    'finance.loans.notesPlaceholder': 'Any additional details...',
    'finance.loans.saveChanges': 'Save Changes',
    'finance.loans.disbursementSection': 'Cash Received (Optional)',
    'finance.loans.disbursementHelp': 'Record the cash you actually received to a wallet. This may differ from the loan principal.',
    'finance.loans.amountReceived': 'Amount Received',
    'finance.loans.receiveToWallet': 'Receive to Wallet',
    'finance.loans.selectWallet': 'Select wallet',
    'finance.loans.noWallet': 'No wallet selected',
    'finance.loans.disbursement': 'Loan Disbursement',
    'finance.loans.description': 'Track your personal loans in a calm, simple way. This is for personal tracking only.',
    'finance.loans.totalRemaining': 'Total Remaining',
    'finance.loans.monthlyPayments': 'Monthly Payments',
    'finance.loans.recordPayment': 'Record Payment',
    'finance.loans.paymentAmount': 'Payment Amount',
    'finance.loans.paymentDate': 'Payment Date',
    'finance.loans.paymentNotes': 'Notes (optional)',
    'finance.loans.paymentNotesPlaceholder': 'e.g., Monthly payment, Extra payment',
    'finance.loans.paidFromWallet': 'Paid from wallet',
    'finance.loans.selectWalletRequired': 'Please select a wallet for this payment',
    'finance.loans.progress': 'Progress',
    'finance.loans.paid': 'paid',
    'finance.loans.paymentHistory': 'Payment History',
    'finance.loans.noLoans': 'No loans yet',
    'finance.loans.noLoansHint': 'Track your personal loans here',
    'finance.loans.congratulations': '🎉 Congratulations! Loan paid off!',
    'finance.loans.paymentRecorded': 'Payment recorded successfully',
    'finance.loans.loanAdded': 'Loan added',
    'finance.loans.loanUpdated': 'Loan updated',
    'finance.loans.loanDeleted': 'Loan deleted',
    'finance.loans.paymentDeleted': 'Payment deleted',
    'finance.selectDay': 'Select day',
    'finance.noSpecificDay': 'No specific day',
    
    // Category Preferences
    'categoryPrefs.title': 'Category Preferences',
    'categoryPrefs.description': 'Show or hide categories to personalize your experience',
    'categoryPrefs.home': 'Home',
    'categoryPrefs.work': 'Work',
    'categoryPrefs.money': 'Money',
    'categoryPrefs.self': 'Self-Care',
    'categoryPrefs.kids': 'Kids',
    'categoryPrefs.homeDesc': 'Household chores and home management',
    'categoryPrefs.workDesc': 'Professional tasks and career',
    'categoryPrefs.moneyDesc': 'Finance and budget management',
    'categoryPrefs.selfDesc': 'Personal wellness and self-care',
    'categoryPrefs.kidsDesc': 'Parenting and children activities',
    
    'tasks.title': 'My Tasks',
    'tasks.addTask': 'Add Task',
    'tasks.quickAdd': 'Quick add task...',
    'tasks.focusToday': 'Focus Today',
    'tasks.allTasks': 'All Tasks',
    'tasks.completed': 'Completed',
    'tasks.priority': 'Priority',
    'tasks.deadline': 'Deadline',
    'tasks.area': 'Area',
    'tasks.delegateTo': 'Delegate to',
    'tasks.notes': 'Notes',
    'tasks.recurring': 'Recurring',
    'tasks.reminder': 'Reminder',
    'tasks.noTasks': 'No tasks yet',
    'tasks.addFirstTask': 'Add your first task to get started',
    'tasks.today': 'Today',
    'tasks.tomorrow': 'Tomorrow',
    'tasks.overdue': 'Overdue',
    'tasks.listView': 'List',
    'tasks.weekView': 'Week',
    'tasks.unscheduled': 'Unscheduled',
    'tasks.high': 'High',
    'tasks.medium': 'Medium',
    'tasks.low': 'Low',
    'tasks.home': 'Home',
    'tasks.kids': 'Kids',
    'tasks.work': 'Work',
    'tasks.money': 'Money',
    'tasks.self': 'Self',
    'tasks.templates': 'Templates',
    
    // Shopping
    'shopping.title': 'Shopping List',
    'shopping.addItem': 'Add Item',
    'shopping.quickAdd': 'Quick add...',
    'shopping.daily': 'Daily',
    'shopping.weekly': 'Weekly',
    'shopping.monthly': 'Monthly',
    'shopping.pantry': 'Pantry',
    'shopping.category': 'Category',
    'shopping.quantity': 'Quantity',
    'shopping.unit': 'Unit',
    'shopping.price': 'Price',
    'shopping.noItems': 'No items yet',
    'shopping.addFirstItem': 'Add your first item',
    'shopping.clearCompleted': 'Clear completed',
    'shopping.total': 'Total',
    'shopping.items': 'items',
    'shopping.share': 'Share List',
    'shopping.templates': 'Templates',
    'shopping.saveTemplate': 'Save as Template',
    'shopping.loadTemplate': 'Load Template',
    'shopping.quickItems': 'Quick Add Items',
    'shopping.editQuickItems': 'Edit Quick Items',
    'shopping.fresh': 'Fresh',
    'shopping.cleaning': 'Cleaning',
    'shopping.household': 'Household',
    'shopping.personal': 'Personal Care',
    'shopping.snacks': 'Snacks',
    'shopping.drinks': 'Drinks',
    'shopping.other': 'Other',
    
    // Self-Care
    'selfcare.title': 'Self-Care Hub',
    'selfcare.subtitle': 'A gentle space for you 💜',
    'selfcare.signInPrompt': 'Please sign in to access your personal self-care space.',
    'selfcare.calmMode': 'Calm mode',
    'selfcare.normal': 'Normal',
    'selfcare.footerMessage': 'Remember: there is no perfect way to take care of yourself.',
    'selfcare.footerMessage2': 'What matters is that you try. 🌱',
    'selfcare.howFeeling': 'How are you feeling today?',
    'selfcare.shareThought': 'Or share a thought... (optional)',
    'selfcare.updateCheckin': 'Update Check-in',
    'selfcare.saveCheckin': 'Save Check-in',
    'selfcare.alreadyCheckedIn': "You've already checked in today ✓",
    'selfcare.thankYouCheckin': 'Thank you for checking in 💜',
    'selfcare.energyCheck': 'Energy Check',
    'selfcare.optional': '(optional)',
    'selfcare.tired': 'Tired',
    'selfcare.okay': 'Okay',
    'selfcare.calm': 'Calm',
    'selfcare.overwhelmed': 'Overwhelmed',
    'selfcare.moodLogged': 'Mood logged 💜',
    'selfcare.sleepLog': 'Sleep Log',
    'selfcare.howDidYouSleep': 'How did you sleep last night?',
    'selfcare.poor': 'Poor',
    'selfcare.fair': 'Fair',
    'selfcare.good': 'Good',
    'selfcare.great': 'Great',
    'selfcare.loggedForToday': 'Logged for today',
    'selfcare.sleepLogged': 'Sleep logged 🌙',
    'selfcare.breathingExercise': 'Breathing Exercise',
    'selfcare.breatheIn': 'Breathe in...',
    'selfcare.hold': 'Hold...',
    'selfcare.breatheOut': 'Breathe out...',
    'selfcare.rest': 'Rest...',
    'selfcare.cycle': 'cycle',
    'selfcare.cycles': 'cycles',
    'selfcare.takeAMoment': 'Take a moment to breathe',
    'selfcare.start': 'Start',
    'selfcare.pause': 'Pause',
    'selfcare.breathingTip': '4 seconds in · 4 seconds hold · 6 seconds out',
    'selfcare.gentleHabits': 'Gentle Habits',
    'selfcare.beginAgain': 'You can always begin again 💜',
    'selfcare.noHabits': 'No habits yet. Add one when you\'re ready.',
    'selfcare.addGentleHabit': 'Add a Gentle Habit',
    'selfcare.addHabit': 'Add Habit',
    'selfcare.habitAdded': 'Habit added 🌱',
    'selfcare.habitRemoved': 'Habit removed',
    'selfcare.day': 'day',
    'selfcare.days': 'days',
    'selfcare.completed': 'completed',
    'selfcare.restCategory': 'Rest',
    'selfcare.movement': 'Movement',
    'selfcare.reflection': 'Reflection',
    'selfcare.gratitudeJournal': 'Gratitude Journal',
    'selfcare.whatGrateful': 'What are you grateful for today?',
    'selfcare.tapToAdd': 'Tap to add your first gratitude',
    'selfcare.imGratefulFor': "I'm grateful for...",
    'selfcare.gratitudeSaved': 'Gratitude saved 🌸',
    'selfcare.gratitudesAdded': "You've already added 3 gratitudes for today 💜",
    'selfcare.ofGratitudes': 'of',
    'selfcare.gratitudesToday': 'gratitudes today',
    'selfcare.completedGratitude': "✓ You've completed today's gratitude practice",
    'selfcare.weeklyWellness': 'Weekly Wellness',
    'selfcare.weeklySnapshot': 'Your self-care snapshot for the past 7 days',
    'selfcare.doingAmazing': "You're doing amazing! 🌟",
    'selfcare.goodProgress': 'Good progress this week!',
    'selfcare.keepGoing': "Keep going, you've got this!",
    'selfcare.smallSteps': 'Small steps count too 💜',
    'selfcare.avgSleep': 'Avg Sleep',
    'selfcare.topMood': 'Top Mood',
    'selfcare.habitsDone': 'Habits Done',
    'selfcare.activeDays': 'Active on',
    'selfcare.of7Days': 'of 7 days',
    'selfcare.startLogging': 'Start logging to see your wellness overview!',
    'selfcare.morningRoutine': 'My Morning Routine',
    'selfcare.wakeUpAt': 'Wake up at',
    'selfcare.dailyAffirmation': 'Daily affirmation',
    'selfcare.firstActivity': 'First activity',
    'selfcare.createMorningRoutine': 'Create Your Morning Routine',
    'selfcare.setupGentleFlow': 'Set up a gentle flow to start each day with intention',
    'selfcare.getStarted': 'Get Started',
    'selfcare.morningRoutineSetup': 'Morning Routine Setup',
    'selfcare.wakeUpTime': 'Wake-Up Time',
    'selfcare.whenStartDay': 'When would you like to start your day?',
    'selfcare.morningAffirmation': 'Morning Affirmation',
    'selfcare.setIntention': 'Set your intention for the day',
    'selfcare.firstSelfCareActivity': 'First Self-Care Activity',
    'selfcare.chooseNurture': 'Choose how to nurture yourself first thing',
    'selfcare.writeOwnOrChoose': 'Write your own or choose one below...',
    'selfcare.routineSaved': 'Morning routine saved! Rise and shine ✨',
    'selfcare.routineDeleted': 'Routine deleted',
    'selfcare.failedSaveRoutine': 'Failed to save routine',
    'selfcare.failedDeleteRoutine': 'Failed to delete routine',
    'selfcare.signInToSave': 'Please sign in to save your routine',
    'selfcare.saving': 'Saving...',
    'selfcare.complete': 'Complete',
    'selfcare.next': 'Next',
    'selfcare.meditation': '5-min Meditation',
    'selfcare.morningStretches': 'Morning Stretches',
    'selfcare.gratitudeJournaling': 'Gratitude Journaling',
    'selfcare.deepBreathing': 'Deep Breathing',
    'selfcare.drinkWater': 'Drink Water',
    'selfcare.getSunlight': 'Get Sunlight',
    'selfcare.affirmation1': 'Today I choose joy and gratitude',
    'selfcare.affirmation2': 'I am capable of amazing things',
    'selfcare.affirmation3': 'I deserve peace and happiness',
    'selfcare.affirmation4': 'I trust the journey of my life',
    'selfcare.affirmation5': 'I am enough, just as I am',
    
    // Reminders
    'reminder.title': 'Reminders',
    'reminder.placeholder': 'Reminder title',
    'reminder.add': 'Add',
    'reminder.noReminders': 'No reminders yet',
    'reminder.fired': 'Fired',
    'reminder.added': 'Reminder added!',
    'reminder.removed': 'Reminder removed',
    'reminder.fillTitleTime': 'Please fill in the title and time',
    
    // Common
    'common.back': 'Back',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.loading': 'Loading...',
    'common.add': 'Add',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.all': 'All',
    'common.success': 'Success',
    'common.error': 'Error',
    'common.update': 'Update',
    'common.submit': 'Submit',
    
    // Toast messages - Tasks
    'toast.taskAdded': 'Task added!',
    'toast.taskUpdated': 'Task updated!',
    'toast.taskDeleted': 'Task deleted',
    'toast.taskCompleted': 'Task completed! Next occurrence created.',
    'toast.maxFocusTasks': 'You can only have 3 focus tasks at a time',
    'toast.templateTasksAdded': 'tasks from template added',
    'toast.taskRescheduled': 'Task rescheduled',
    'toast.errorFetchingTasks': 'Error fetching tasks',
    'toast.errorAddingTask': 'Error adding task',
    'toast.errorUpdatingTask': 'Error updating task',
    'toast.errorDeletingTask': 'Error deleting task',
    
    // Toast messages - Shopping
    'toast.itemAdded': 'Item added!',
    'toast.itemDeleted': 'Item deleted',
    'toast.itemsCleared': 'Items cleared',
    'toast.templateSaved': 'Template saved!',
    'toast.templateLoaded': 'Template loaded!',
    'toast.templateDeleted': 'Template deleted',
    'toast.linkCopied': 'Link copied!',
    'toast.errorFetchingItems': 'Error fetching items',
    'toast.errorAddingItem': 'Error adding item',
    'toast.errorDeletingItem': 'Error deleting item',
    
    // Toast messages - Finance
    'toast.transactionAdded': 'Transaction added!',
    'toast.transactionDeleted': 'Transaction deleted',
    'toast.budgetSet': 'Budget set!',
    'toast.budgetUpdated': 'Budget updated!',
    'toast.budgetDeleted': 'Budget deleted',
    'toast.categoryCreated': 'Category created!',
    'toast.categoryDeleted': 'Category deleted',
    'toast.savingsGoalCreated': 'Savings goal created!',
    'toast.savingsGoalDeleted': 'Savings goal deleted',
    'toast.recurringAdded': 'Recurring transaction added!',
    'toast.dataRefreshed': 'Data refreshed!',
    'toast.errorFetchingExpenses': 'Error fetching expenses',
    'toast.errorAddingExpense': 'Error adding expense',
    'toast.noLastMonthBudgets': 'No budget goals found from last month',
    
    // Additional Tasks translations
    'tasks.oneStep': 'One step at a time. You\'ve got this.',
    'tasks.addWithDetails': 'Add with details',
    'tasks.removeFromFocus': 'Remove from focus',
    'tasks.addToFocus': 'Add to today\'s focus',
    'tasks.editTask': 'Edit task',
    'tasks.deleteTask': 'Delete task',
    'tasks.undo': 'Undo',
    'tasks.atDeadline': 'At time of deadline',
    'tasks.15min': '15 minutes before',
    'tasks.30min': '30 minutes before',
    'tasks.1hour': '1 hour before',
    'tasks.2hours': '2 hours before',
    'tasks.1day': '1 day before',
    'tasks.none': 'None',
    'tasks.subtasks': 'Subtasks',
    'tasks.addSubtask': 'Add subtask',
    'tasks.saveTemplate': 'Save as Template',
    'tasks.noRecurring': 'No recurring',
    
    // Additional Shopping translations
    'shopping.organizeStressFree': 'Organize your shopping, stress-free 🛒',
    'shopping.needToBuy': 'Need to buy',
    'shopping.bought': 'Bought',
    'shopping.copyToDaily': 'Copy to Daily',
    'shopping.clearAll': 'Clear all',
    'shopping.inStock': 'In Stock',
    'shopping.lowStock': 'Low',
    'shopping.outOfStock': 'Out',
    'shopping.itemName': 'Item name',
    'shopping.createShareLink': 'Create Share Link',
    'shopping.shareableLink': 'Shareable Link',
    'shopping.copyLink': 'Copy Link',
    'shopping.deleteTemplate': 'Delete Template',
    'shopping.noTemplates': 'No templates yet',
    
    // Additional Finance translations
    'finance.manageFinances': 'Manage your finances wisely',
    'finance.insights': 'AI Insights',
    'finance.report': 'Monthly Report',
    'finance.noData': 'No data yet',
    'finance.addFirstTransaction': 'Add your first transaction to get started',
    'finance.expenseType': 'Expense',
    'finance.incomeType': 'Income',
    'finance.savingType': 'Saving',
    'finance.cash': 'Cash',
    'finance.bankTransfer': 'Bank Transfer',
    'finance.creditCard': 'Credit Card',
    'finance.eWallet': 'E-Wallet',
    'finance.addToGoal': 'Add to Goal',
    'finance.progress': 'Progress',
    'finance.copyFromLastMonth': 'Copy from Last Month',
    'finance.noSavingsGoals': 'No savings goals yet',
    'finance.createFirstGoal': 'Create your first savings goal',
    'finance.savings.amountToAdd': 'Amount to Add',
    'finance.savings.fromWallet': 'From wallet',
    'finance.savings.selectWallet': 'Select wallet',
    'finance.savings.selectWalletRequired': 'Please select a wallet for this transfer',
    'finance.savings.addFunds': 'Add Funds',
    
    // Landing Page - Hero
    'landing.badge': 'Empowering Moms Worldwide',
    'landing.headline': 'Run Your Home Like a',
    'landing.headlineHighlight': 'CEO',
    'landing.subheadline': 'TechMom helps you',
    'landing.thrive': 'thrive',
    'landing.subheadlineEnd': ', not just survive. Manage family, home, and business from one powerful dashboard.',
    'landing.startFree': 'Start Free Today',
    'landing.seeHow': 'See How It Works',
    
    // Landing Page - Problem/Solution
    'landing.problemTitle': 'Juggling Too Much?',
    'landing.problemHighlight': 'We Get It.',
    'landing.problemDesc': 'Between family, home, and work, modern moms do it all. TechMom brings everything together in one beautiful, intelligent dashboard.',
    'landing.smartTasks': 'Smart Tasks',
    'landing.smartTasksDesc': 'Never miss a deadline with AI-powered task prioritization',
    'landing.financeTracker': 'Finance Tracker',
    'landing.financeTrackerDesc': 'Track family spending and save money effortlessly',
    'landing.menuPlanner': 'Menu Planner',
    'landing.menuPlannerDesc': 'Plan meals and generate shopping lists automatically',
    'landing.familyCalendar': 'Family Calendar',
    'landing.familyCalendarDesc': 'Coordinate schedules and delegate tasks seamlessly',
    'landing.selfCareGoals': 'Self-Care Goals',
    'landing.selfCareGoalsDesc': 'Prioritize yourself with gentle reminders and tracking',
    'landing.aiAssistant': 'AI Assistant',
    'landing.aiAssistantDesc': 'Get personalized suggestions, meal ideas, financial tips, and motivational support from your intelligent assistant that learns your family\'s unique needs.',
    
    // Landing Page - App Preview
    'landing.previewTitle': 'Beautiful Design,',
    'landing.previewHighlight': 'Powerful Features',
    'landing.previewDesc': 'Access your dashboard anywhere — on your phone, tablet, or desktop. Everything syncs in real-time.',
    'landing.mobile': 'Mobile',
    'landing.tablet': 'Tablet',
    'landing.desktop': 'Desktop',
    'landing.realtimeSync': 'Real-time Sync',
    'landing.realtimeSyncDesc': 'Changes update instantly across all devices',
    'landing.offlineMode': 'Offline Mode',
    'landing.offlineModeDesc': 'Keep working even without internet',
    'landing.securePrivate': 'Secure & Private',
    'landing.securePrivateDesc': 'Your family data is encrypted and safe',
    
    // Landing Page - Testimonials
    
    // Landing Page - Final CTA
    'landing.ctaTitle': 'Ready to take control of your day?',
    'landing.ctaDesc': 'Bring your home, money, business, and well-being together in one calm place.',
    
    // Landing Page - Footer
    'landing.footerDesc': 'Empowering moms to manage family, home, and business from one dashboard — with AI, community, and balance.',
    'landing.product': 'Product',
    'landing.features': 'Features',
    'landing.pricing': 'Pricing',
    'landing.faq': 'FAQ',
    'landing.company': 'Company',
    'landing.about': 'About',
    'landing.contact': 'Contact',
    'landing.blog': 'Blog',
    'landing.privacyPolicy': 'Privacy Policy',
    'landing.termsOfService': 'Terms of Service',
    'landing.copyright': '© 2025 TechMom v1.0 (Beta). Made with',
    'landing.forMoms': 'for moms everywhere.',
    'landing.terms': 'Terms',
    'landing.privacy': 'Privacy',
    'landing.cookies': 'Cookies',

    // Landing Page — Refined (2026)
    'landing.heroBadge': 'One dashboard for your whole life',
    'landing.heroHeadline': 'Run Your Life Like a',
    'landing.heroHeadlineHighlight': 'CEO.',
    'landing.heroSubheadline': 'TechMom helps moms manage family, home, money, and business from one simple dashboard.',
    'landing.featuresSectionTitle': 'What TechMom helps you manage',
    'landing.featuresSectionDesc': 'Every part of your day, in one calm place.',
    'landing.featGroupHome': 'Home',
    'landing.featGroupMoney': 'Money',
    'landing.featGroupBusiness': 'Business',
    'landing.featGroupYou': 'You',
    'landing.featGroupSmart': 'Smart Support',
    'landing.featDailyRoutine': 'Daily Routine',
    'landing.featMenu': 'Menu Planner',
    'landing.featShopping': 'Shopping List',
    'landing.featTasks': 'Tasks',
    'landing.featExpense': 'Expense Tracker',
    'landing.featWallet': 'Wallet',
    'landing.featSavings': 'Savings & planning',
    'landing.featBusiness': 'Business Hub',
    'landing.featSelfCare': 'Self-Care',
    'landing.featMovement': 'Movement',
    'landing.featJournal': 'Journal',
    'landing.featAI': 'AI Assistant',
    'landing.featReminders': 'Reminders',
    'landing.featCommunity': 'Community',
    'landing.simpleTitle': 'Everything that matters. In one place.',
    'landing.simpleDesc': "From your family's daily routine to your money, business, and personal goals — TechMom brings everything together so you can spend less time managing life and more time living it.",
    'landing.howTitle': 'How it works',
    'landing.howStep1Title': 'Organize',
    'landing.howStep1Desc': 'Bring your daily life into one dashboard.',
    'landing.howStep2Title': 'Manage',
    'landing.howStep2Desc': 'Track tasks, money, routines, and your business.',
    'landing.howStep3Title': 'Grow',
    'landing.howStep3Desc': 'Use your time and money more intentionally.',
    'landing.trustTitle': 'Built by a mom, for moms.',
    'landing.trustDesc': 'TechMom is designed around the real, everyday reality of running a home, a family, and a life — without the pressure or the noise.',
    'landing.ctaButton': 'Start Free',
    'landing.ctaNote': 'No credit card required to start.',

    // Premium section
    'landing.premiumBadge': 'TechMom Premium',
    'landing.premiumTitle': 'TechMom Premium',
    'landing.premiumDesc': 'Unlock the deeper tools that help you stay on top of your money, your business, and your well-being.',
    'landing.premiumFeatureFinance': 'Finance — full income, expenses, budgets, and wallets',
    'landing.premiumFeatureBusiness': 'Business Hub — manage your shop and products',
    'landing.premiumFeatureAI': 'AI Assistant — log expenses and get help by chat',
    'landing.premiumFeatureJournal': 'Journal — a quiet space to reflect and write',
    'landing.premiumFeatureSelfCare': 'Self-Care — gentle check-ins and calm mode',
    'landing.premiumFeatureMovement': 'Movement — light activity tracking',
    'landing.premiumButton': 'Upgrade to Premium',
    'landing.premiumNote': 'One-off payment for 30 days, no auto-renewal. Payment handled securely by Duitku.',
    'premium.starting': 'Opening secure payment...',
    'premium.startError': 'We could not start the payment. Please try again.',
    'premium.notConfigured': 'Payment is not available yet. Please try again later.',
    'payment.successTitle': 'Payment received',
    'payment.successDesc': 'Your TechMom Premium access is active for the next month. Enjoy.',
    'payment.pendingTitle': 'Waiting for confirmation',
    'payment.pendingDesc': 'We are confirming your payment. This page updates automatically.',
    'payment.failedTitle': 'Payment not completed',
    'payment.failedDesc': 'Your payment was cancelled or did not go through. Nothing was charged and Premium was not activated.',
    'payment.goDashboard': 'Go to dashboard',
    'payment.tryAgain': 'Try again',
    'payment.cancelledNotice': 'Payment was cancelled or not completed.',
    'payment.processingTitle': 'Your payment is being processed',
    'payment.checkStatus': 'Check status',
    'payment.tryLater': 'Please try again in a moment',
    'payment.oneOffPeriod': 'One-off payment for 30 days, no auto-renewal.',
    'payment.periodEnd': 'Current access ends',
    'payment.renew': 'Renew',
    'payment.renewalNotice': 'Your Premium ends on [date]. Renew?',

    // Contact section
    'landing.contactTitle': 'Contact & Support',
    'landing.contactDesc': 'We are here to help. Reach out anytime and we will respond as soon as we can.',
    'landing.contactEmailLabel': 'Email',
    'landing.contactWhatsAppLabel': 'WhatsApp',
    'landing.contactAddressLabel': 'Business address',
    'landing.contactAddressValue': 'Jalan Glogor Carik Gang Ratna Indah No 8, Denpasar Selatan, Bali',

    // Journal
    'journal.title': 'Journal',
    'journal.subtitle': 'A quiet space to write, reflect, and breathe.',
    'journal.emptyState': "You don't have any journal entries yet.",
    'journal.emptyStateHint': 'Start with one small thought today.',
    'journal.newEntry': 'New Entry',
    'journal.newEntryTitle': 'New Journal Entry',
    'journal.editEntry': 'Edit Entry',
    'journal.titleLabel': 'Title (optional)',
    'journal.titlePlaceholder': "e.g. Today's thoughts",
    'journal.dateLabel': 'Date',
    'journal.contentPlaceholder': 'Write freely. No rules. This space is just for you.',
    'journal.save': 'Save Entry',
    'journal.cancel': 'Cancel',
    'journal.untitled': 'Untitled',
    
    // Business Hub
    'business.title': 'Business Hub',
    'business.quickAction': 'Quick Action',
    'business.totalRevenue': 'Total Revenue',
    'business.invoices': 'Invoices',
    'business.customers': 'Customers',
    'business.inventory': 'Inventory',
    'business.orders': 'Orders',
    'business.paid': 'paid',
    'business.backToOrders': 'Back to Orders',
    'business.order': 'Order',
    'business.due': 'Due',
    'business.noOrders': 'No orders yet',
    'business.noInvoices': 'No invoices yet',
    'business.noCustomers': 'No customers yet',
    'business.noInventory': 'No inventory yet',
    'business.stock': 'Stock',
    
    // Marketplace additional
    'marketplace.viewCart': 'View Cart',
    'marketplace.viewAll': 'View all',
    'marketplace.securePayment': 'Secure Shopping',
    'marketplace.momOwned': 'Mom-Owned Businesses',
    'marketplace.qualityGuaranteed': 'Quality Guaranteed',
    'marketplace.madeWithLove': 'Made with love by moms, for moms',
    'marketplace.noProducts': 'No products found',
    'marketplace.noProductsHint': 'Try a different search or category',
    'marketplace.productDeleted': 'Product deleted',
    'marketplace.productRestored': 'Product restored',
    'marketplace.shopDeleted': 'Shop deleted',
    'marketplace.shopRestored': 'Shop restored',
    'marketplace.deleteError': 'Failed to delete',
    
    // AI Assistant
    'ai.title': 'AI Money Coach',
    'ai.subtitle': 'Your personal money companion',
    'ai.welcome': 'Hi there!',
    'ai.welcomeDesc': "I'm here to help with your finances and life management. Ask me anything, upload a receipt, or pick a topic below.",
    'ai.quickQuestions': 'Quick Questions',
    'ai.canIAfford': 'Can I afford this?',
    'ai.analyzeWeek': 'Analyze my week',
    'ai.moneyLeaks': 'Money leaks?',
    'ai.todaysFocus': "Today's focus",
    'ai.helpSave': 'Help me save',
    'ai.analyzing': 'Analyzing your finances...',
    'ai.uploadHint': 'Upload receipts or bills for help logging expenses',
    'ai.askPlaceholder': 'Ask about your finances...',
    'ai.loginFirst': 'Please log in first to use AI Money Coach.',
    'ai.error': 'Sorry, an error occurred. Please try again!',
    'ai.sessionExpired': 'Session expired',
    'ai.pleaseLoginAgain': 'Please log in again.',
    'ai.tooManyRequests': 'Too many requests',
    'ai.waitAndRetry': 'Please wait a moment and try again.',
    'ai.invalidFile': 'Invalid file',
    'ai.failedProcessImage': 'Failed to process image',
    'ai.tryAnotherImage': 'Try again with another image',
    
    // Unified AI Assistant
    'unifiedAi.title': 'TechMom AI',
    'unifiedAi.subtitle': 'Your life assistant',
    'unifiedAi.welcome': 'Hi! I can help with expenses, tasks, shopping, meals, and self-care. What would you like to do?',
    'unifiedAi.placeholder': 'Ask me anything...',
    'unifiedAi.pleaseLogin': 'Please log in to use the AI assistant.',
    'unifiedAi.noResponse': 'No response. Please try again.',
    'unifiedAi.error': 'Sorry, something went wrong. Please try again.',
    'unifiedAi.thinking': 'Thinking...',
    'unifiedAi.logExpense': 'Log expense',
    'unifiedAi.addTask': 'Add task',
    'unifiedAi.addShopping': 'Add to shopping',
    'unifiedAi.planMeal': 'Plan meal',
    'unifiedAi.logMood': 'Log mood',
    'unifiedAi.confirmAction': 'Confirm Action',
    'unifiedAi.reviewBeforeConfirm': 'Please review the details before confirming.',
    'unifiedAi.cancel': 'Cancel',
    'unifiedAi.confirm': 'Confirm',
    'unifiedAi.actionSuccess': 'Done!',
    'unifiedAi.actionFailed': 'Action failed',
    'unifiedAi.actionCancelled': 'Action cancelled.',
    'unifiedAi.preview.addExpense': 'Add Expense',
    'unifiedAi.preview.addIncome': 'Add Income',
    'unifiedAi.preview.amount': 'Amount',
    'unifiedAi.preview.category': 'Category',
    'unifiedAi.preview.wallet': 'Wallet',
    'unifiedAi.preview.notes': 'Notes',
    'unifiedAi.preview.createTask': 'Create Task',
    'unifiedAi.preview.title': 'Title',
    'unifiedAi.preview.priority': 'Priority',
    'unifiedAi.preview.deadline': 'Deadline',
    'unifiedAi.preview.area': 'Area',
    'unifiedAi.preview.completeTask': 'Complete Task',
    'unifiedAi.preview.task': 'Task',
    'unifiedAi.preview.addShopping': 'Add to Shopping List',
    'unifiedAi.preview.item': 'Item',
    'unifiedAi.preview.qty': 'Quantity',
    'unifiedAi.preview.list': 'List',
    'unifiedAi.preview.planMeal': 'Plan Meal',
    'unifiedAi.preview.meal': 'Meal',
    'unifiedAi.preview.day': 'Day',
    'unifiedAi.preview.type': 'Type',
    'unifiedAi.preview.logMood': 'Log Mood',
    'unifiedAi.preview.mood': 'Mood',
    'unifiedAi.preview.logSleep': 'Log Sleep',
    'unifiedAi.preview.quality': 'Quality',
    'unifiedAi.preview.hours': 'Hours',
    'unifiedAi.preview.addGratitude': 'Add Gratitude',
    'unifiedAi.preview.logMovement': 'Log Movement',
    'unifiedAi.preview.activity': 'Activity',
    'unifiedAi.preview.duration': 'Duration',
    
    // Language
    'lang': 'en',
  },
  id: {
    // Simple keys
    'dashboard': 'Beranda',
    'tasks': 'Tugas',
    'weeklyMenu': 'Menu Mingguan',
    'addMeal': 'Tambah Menu',
    'todaysExpenses': 'Pengeluaran Hari Ini',
    'totalSpent': 'total pengeluaran',
    'selfCare': 'Perawatan Diri',
    'trackWellness': 'Pantau kesehatan harian',
    'shop': 'Toko',
    'createShop': 'Buat Toko Saya',
    'shopName': 'Nama Toko',
    'description': 'Deskripsi',
    'category': 'Kategori',
    'uploadLogo': 'Unggah logo',
    'searchProducts': 'Cari produk...',
    
    // Menu Planner
    'menu.title': 'Menu Mingguan',
    'menu.subtitle': 'Rencanakan menu dan permudah belanja bahan',
    'menu.planner': 'Rencana Menu',
    'menu.addMeal': 'Tambah Menu',
    'menu.addNewMeal': 'Tambah Menu Baru',
    'menu.mealName': 'Nama Menu',
    'menu.dayOfWeek': 'Hari',
    'menu.mealType': 'Waktu Makan',
    'menu.ingredients': 'Bahan-bahan (pisahkan dengan koma)',
    'menu.ingredientsPlaceholder': 'Nasi, Ayam, Sayuran',
    'menu.breakfast': 'Sarapan',
    'menu.lunch': 'Makan Siang',
    'menu.dinner': 'Makan Malam',
    'menu.snack': 'Cemilan',
    'menu.selectType': 'Pilih waktu',
    'menu.monday': 'Senin',
    'menu.tuesday': 'Selasa',
    'menu.wednesday': 'Rabu',
    'menu.thursday': 'Kamis',
    'menu.friday': 'Jumat',
    'menu.saturday': 'Sabtu',
    'menu.sunday': 'Minggu',
    
    // Navigation
    'nav.dashboard': 'Beranda',
    'nav.tasks': 'Tugas',
    'nav.dailyRoutine': 'Rutinitas Harian',
    'nav.menu': 'Menu Mingguan',
    'nav.finance': 'Catatan Keuangan',
    'nav.selfcare': 'Perawatan Diri',
    'nav.journal': 'Jurnal',
    'nav.movement': 'Gerak Tubuh',
    'nav.community': 'Komunitas',
    'nav.marketplace': 'Toko Online',
    'nav.business': 'Bisnis Saya',
    'nav.cart': 'Keranjang',
    'nav.signin': 'Masuk',
    'nav.signout': 'Keluar',
    
    // Movement
    'movement.title': 'Gerak Tubuh',
    'movement.subtitle': 'Bergerak dengan cara yang nyaman',
    'movement.emptyTitle': 'Bergerak dengan cara yang terasa nyaman hari ini.',
    'movement.emptySubtitle': 'Tanpa aturan. Tanpa tekanan.',
    'movement.add': 'Tambah Aktivitas',
    'movement.addTitle': 'Tambah Aktivitas',
    'movement.activityName': 'Nama aktivitas',
    'movement.activityPlaceholder': 'misalnya Jalan kaki, Stretching',
    'movement.goal': 'Target (opsional)',
    'movement.goalPlaceholder': 'misalnya 20 menit',
    'movement.goalLabel': 'Target',
    'movement.duration': 'Durasi (opsional)',
    'movement.durationPlaceholder': 'Menit',
    'movement.date': 'Tanggal',
    'movement.notes': 'Catatan (opsional)',
    'movement.notesPlaceholder': 'Bagaimana rasanya?',
    'movement.save': 'Simpan',
    'movement.saved': 'Aktivitas tersimpan!',
    'movement.minutes': 'menit',
    
    // Auth
    'auth.title': 'Selamat Datang di TechMom',
    'auth.subtitle': 'Platform lengkap untuk ibu modern',
    'auth.signin': 'Masuk',
    'auth.signup': 'Daftar',
    'auth.email': 'Email',
    'auth.password': 'Kata Sandi',
    'auth.fullname': 'Nama Lengkap',
    'auth.forgotpassword': 'Lupa kata sandi?',
    'auth.noaccount': 'Belum punya akun?',
    'auth.haveaccount': 'Sudah punya akun?',
    'auth.signinhere': 'Masuk',
    'auth.signuphere': 'Daftar',
    'auth.loading': 'Mohon tunggu...',
    'auth.welcomeback': 'Selamat datang kembali!',
    'auth.createaccount': 'Buat akun Anda',
    'auth.accountcreated': 'Akun berhasil dibuat! Silakan cek email Anda.',
    'auth.alreadyregistered': 'Email ini sudah terdaftar. Silakan masuk.',
    
    // Marketplace
    'marketplace.title': 'Pasar TechMom',
    'marketplace.subtitle': 'Belanja dari ibu pengusaha hebat',
    'marketplace.search': 'Cari produk...',
    'marketplace.categories': 'Belanja per Kategori',
    'marketplace.featured': 'Toko Pilihan',
    'marketplace.products': 'Semua Produk',
    'marketplace.addtocart': 'Tambah ke Keranjang',
    'marketplace.createShop': 'Buat Toko Saya',
    'marketplace.mommade': 'Buatan Ibu',
    'marketplace.clothing': 'Pakaian',
    'marketplace.food': 'Makanan',
    'marketplace.digital': 'Produk Digital',
    'marketplace.baby': 'Bayi & Anak',
    'marketplace.crafts': 'Seni & Kerajinan',
    'marketplace.books': 'Buku',
    'marketplace.gifts': 'Hadiah',
    'marketplace.home': 'Rumah & Dekorasi',
    'marketplace.beauty': 'Kecantikan',
    'marketplace.new': 'Baru',
    'marketplace.clearFilter': 'Hapus filter',
    'marketplace.sortNewest': 'Terbaru',
    'marketplace.sortOldest': 'Terlama',
    'marketplace.sortPriceLow': 'Harga: Terendah',
    'marketplace.sortPriceHigh': 'Harga: Tertinggi',
    'marketplace.sortNameAZ': 'Nama: A ke Z',
    'marketplace.sortNameZA': 'Nama: Z ke A',
    
    // Community
    'community.title': 'Komunitas',
    'community.shareWith': 'Bagikan dengan komunitas',
    'community.whatsOnMind': 'Apa yang sedang kamu pikirkan?',
    'community.charactersRemaining': 'karakter tersisa',
    'community.category': 'Kategori',
    'community.post': 'Posting',
    'community.likes': 'Suka',
    'community.comment': 'Komentar',
    'community.anonymous': 'Anonim',
    'community.parenting': 'Parenting',
    'community.cooking': 'Memasak',
    'community.businessMoms': 'Ibu Pengusaha',
    'community.selfCare': 'Perawatan Diri',
    'community.general': 'Umum',
    'community.postCreated': 'Postingan dibuat!',
    'community.errorCreating': 'Gagal membuat postingan',
    'community.loginToPost': 'Silakan masuk untuk posting',
    'community.loginToLike': 'Silakan masuk untuk menyukai',
    'community.errorLike': 'Gagal memperbarui suka',
    
    // Product
    'product.soldby': 'Dijual oleh',
    'product.size': 'Ukuran',
    'product.color': 'Warna',
    'product.quantity': 'Jumlah',
    'product.addtocart': 'Tambah ke Keranjang',
    'product.buynow': 'Beli Sekarang',
    'product.shipping': 'Pengiriman',
    'product.returns': 'Pengembalian',
    'product.description': 'Deskripsi Produk',
    'product.instock': 'Tersedia',
    'product.outofstock': 'Habis',
    'product.reviews': 'Ulasan',
    'product.writeReview': 'Tulis Ulasan',
    'product.editReview': 'Edit Ulasan',
    'product.yourRating': 'Rating Anda',
    'product.yourReview': 'Ulasan Anda (opsional)',
    'product.reviewPlaceholder': 'Bagikan pendapat Anda tentang produk ini...',
    'product.noReviews': 'Belum ada ulasan. Jadilah yang pertama!',
    'product.addedToWishlist': 'Ditambahkan ke wishlist',
    'product.removedFromWishlist': 'Dihapus dari wishlist',
    
    // Cart
    'cart.title': 'Keranjang Belanja',
    'cart.empty': 'Keranjang Anda kosong',
    'cart.emptyDesc': 'Mulai tambahkan produk ke keranjang Anda!',
    'cart.browse': 'Lihat Produk',
    'cart.remove': 'Hapus',
    'cart.removed': 'Produk dihapus dari keranjang',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Pengiriman',
    'cart.shippingCalc': 'Dihitung saat checkout',
    'cart.total': 'Total',
    'cart.checkout': 'Lanjut ke Pembayaran',
    'cart.continue': 'Lanjut Belanja',
    'cart.free': 'Gratis',
    'cart.loginCheckout': 'Silakan masuk untuk checkout',
    'cart.orderSummary': 'Ringkasan Pesanan',
    
    // Checkout
    'checkout.title': 'Pembayaran',
    'checkout.shipping': 'Informasi Pengiriman',
    'checkout.address': 'Alamat Pengiriman',
    'checkout.addressPlaceholder': 'Masukkan alamat pengiriman lengkap Anda',
    'checkout.payment': 'Metode Pembayaran',
    'checkout.sandboxMode': 'Mode Sandbox:',
    'checkout.testPayment': 'Gunakan metode pembayaran uji coba di bawah',
    'checkout.sandboxCard': 'Kartu Kredit Sandbox',
    'checkout.testCard': 'Uji pembayaran kartu',
    'checkout.sandboxWallet': 'E-Wallet Sandbox',
    'checkout.testWallet': 'Uji dompet digital',
    'checkout.cod': 'Bayar di Tempat',
    'checkout.codDesc': 'Bayar saat menerima barang',
    'checkout.cardNumber': 'Nomor Kartu',
    'checkout.walletId': 'ID Dompet',
    'checkout.testValue': 'Nilai uji apa pun akan berfungsi dalam mode sandbox',
    'checkout.placeorder': 'Pesan Sekarang',
    'checkout.processing': 'Memproses...',
    'checkout.summary': 'Ringkasan Pesanan',
    'checkout.confirmed': 'Pesanan Dikonfirmasi!',
    'checkout.thankyou': 'Terima kasih atas pembelian Anda. Pesanan Anda telah berhasil diproses.',
    'checkout.reference': 'Referensi Pembayaran:',
    'checkout.saveRef': 'Simpan referensi ini untuk catatan Anda. Ini adalah pembayaran sandbox.',
    'checkout.continueshop': 'Lanjut Belanja',
    'checkout.gotodash': 'Ke Beranda',
    'checkout.enterAddress': 'Silakan masukkan alamat pengiriman',
    'checkout.enterCard': 'Silakan masukkan detail kartu/dompet',
    'checkout.processingPayment': 'Memproses pembayaran sandbox...',
    'checkout.paymentSuccess': 'Pembayaran berhasil!',
    'checkout.orderSuccess': 'Pesanan berhasil dibuat!',
    'checkout.orderError': 'Gagal membuat pesanan',
    'checkout.emailSent': 'Email konfirmasi pesanan terkirim!',
    'checkout.emailFailed': 'Pesanan dibuat tapi email gagal terkirim',
    
    // Dashboard
    'dashboard.greeting.morning': 'Selamat Pagi',
    'dashboard.greeting.afternoon': 'Selamat Siang',
    'dashboard.greeting.evening': 'Selamat Malam',
    'dashboard.lets_make_today': 'Mari jadikan hari ini luar biasa!',
    'dashboard.tasks_due_today': 'Tugas Hari Ini',
    'dashboard.pending_items': 'tugas tertunda',
    'dashboard.todays_expenses': 'Pengeluaran Hari Ini',
    'dashboard.total_spent': 'total pengeluaran',
    'dashboard.create_my_shop': 'Buat Toko Saya',
    'dashboard.shop_by_category': 'Belanja Berdasarkan Kategori',
    'dashboard.food': 'Makanan',
    'dashboard.digital_products': 'Produk Digital',
    'dashboard.clothing': 'Pakaian',
    'dashboard.mom_made': 'Buatan Ibu',
    'dashboard.search_products': 'Cari produk...',
    'dashboard.menu_planner': 'Menu Harian',
    'dashboard.plan_meals': 'Rencanakan menu',
    'dashboard.weekly_schedule': 'jadwal mingguan',
    'dashboard.self_care': 'Perawatan Diri',
    'dashboard.track_wellness': 'Pantau kesehatanmu',
    'dashboard.daily_goals': 'target harian',
    'dashboard.quick_actions': 'Aksi Cepat',
    'dashboard.add_task': 'Tambah Tugas',
    'dashboard.add_expense': 'Tambah Pengeluaran',
    'dashboard.add_meal': 'Tambah Menu',
    'dashboard.techmom_tip': 'Tips TechMom Hari Ini',
    'dashboard.tip_content': 'Mulailah harimu dengan menetapkan 3 prioritas utama. Yang lainnya bisa menunggu!',
    
    // Finance
    'finance.title': 'Catatan Keuangan',
    'finance.subtitle': 'Kelola keuanganmu dengan tenang',
    'finance.expenses': 'Pengeluaran',
    'finance.income': 'Pemasukan',
    'finance.savings': 'Tabungan',
    'finance.balance': 'Saldo',
    'finance.balanceHelper': 'Total saldo dari dompet Anda',
    'finance.totalRecorded': 'Total tercatat',
    'finance.savedSoFar': 'Tabungan sejauh ini',
    'finance.lifetimeTotal': 'Total selamanya',
    'finance.periodTotal': 'Periode ini',
    'finance.netChange': 'Neto',
    
    // Period Filter
    'finance.period.viewing': 'Melihat',
    'finance.period.today': 'Hari Ini',
    'finance.period.thisMonth': 'Bulan Ini',
    'finance.period.lastMonth': 'Bulan Lalu',
    'finance.period.thisYear': 'Tahun Ini',
    'finance.period.custom': 'Rentang Khusus',
    'finance.period.selectCustomRange': 'Atau pilih rentang khusus',
    'finance.period.comparison': 'vs Periode Sebelumnya',
    'finance.period.noPreviousData': 'Tidak ada data dari periode sebelumnya untuk dibandingkan',
    'finance.wallets': 'Dompet',
    'finance.addWallet': 'Tambah Dompet',
    'finance.editWallet': 'Edit Dompet',
    'finance.walletName': 'Nama Dompet',
    'finance.startingBalance': 'Saldo Awal',
    'finance.selectWallet': 'Pilih Dompet',
    'finance.noWallets': 'Belum ada dompet',
    'finance.noWalletHint': 'Dompet Anda akan dibuat secara otomatis.',
    'finance.totalWalletBalance': 'Total Saldo Dompet',
    'finance.walletBalance': 'Saldo',
    'finance.defaultWallet': 'Utama',
    'finance.setAsDefault': 'Jadikan utama',
    'finance.transferMoney': 'Transfer Uang',
    'finance.transferBetweenWallets': 'Transfer Antar Dompet',
    'finance.fromWallet': 'Dari Dompet',
    'finance.toWallet': 'Ke Dompet',
    'finance.transferAmount': 'Jumlah Transfer',
    'finance.transfer': 'Transfer',
    'finance.selectSourceWallet': 'Pilih dompet asal',
    'finance.selectDestWallet': 'Pilih dompet tujuan',
    'finance.transferSuccess': 'Transfer berhasil',
    'finance.transferError': 'Gagal melakukan transfer',
    'finance.sameWalletError': 'Dompet asal dan tujuan tidak boleh sama',
    'finance.walletBalanceHistory': 'Riwayat Saldo Dompet',
    'finance.filterByWallet': 'Filter Dompet',
    'finance.allWallets': 'Semua Dompet',
    'finance.noWallet': 'Tanpa Dompet',
    'finance.walletDetails': 'Detail Dompet',
    'finance.addIncomeToWallet': 'Tambah Pemasukan',
    'finance.addExpenseFromWallet': 'Tambah Pengeluaran',
    'finance.transferFromWallet': 'Transfer',
    'finance.manageWallet': 'Kelola Dompet',
    'finance.addExpense': 'Tambah Pengeluaran',
    'finance.addIncome': 'Tambah Pemasukan',
    'finance.addSaving': 'Tambah Tabungan',
    'finance.addNew': 'Tambah Baru',
    'finance.editTransaction': 'Edit Transaksi',
    'finance.type': 'Jenis',
    'finance.amount': 'Jumlah (IDR)',
    'finance.date': 'Tanggal',
    'finance.paymentMethod': 'Metode Pembayaran',
    'finance.notes': 'Catatan',
    'finance.all': 'Semua',
    'finance.budget': 'Target Anggaran',
    'finance.setBudget': 'Atur Anggaran',
    'finance.budgetFor': 'Anggaran untuk',
    'finance.spent': 'terpakai',
    'finance.remaining': 'tersisa',
    'finance.overBudget': 'melebihi anggaran',
    'finance.recurring': 'Transaksi Berulang',
    'finance.recurringHelper': 'Otomatis menambahkan transaksi sesuai jadwal.',
    'finance.addRecurring': 'Tambah Berulang',
    'finance.frequency': 'Frekuensi',
    'finance.daily': 'Harian',
    'finance.weekly': 'Mingguan',
    'finance.monthly': 'Bulanan',
    'finance.yearly': 'Tahunan',
    'finance.startDate': 'Tanggal Mulai',
    'finance.nextRun': 'Berikutnya',
    'finance.active': 'Aktif',
    'finance.paused': 'Dijeda',
    'finance.overview': 'Ringkasan',
    'finance.transactions': 'Transaksi',
    'finance.budgets': 'Anggaran',
    'finance.savingsGoals': 'Target Tabungan',
    'finance.thisMonth': 'Bulan Ini',
    'finance.noTransactions': 'Belum ada transaksi',
    'finance.addFirst': 'Tambahkan transaksi pertamamu',
    'finance.category': 'Kategori',
    'finance.search': 'Cari transaksi...',
    'finance.export': 'Ekspor PDF',
    'finance.selectCategory': 'Pilih kategori',
    'finance.monthlyReport': 'Laporan Bulanan',
    'finance.financeReport': 'Laporan Keuangan',
    'finance.spendingByCategory': 'Pengeluaran per Kategori',
    'finance.topSpending': 'Pengeluaran Terbesar',
    'finance.budgetPerformance': 'Pencapaian Anggaran',
    'finance.vsLastMonth': 'dari bulan lalu',
    'finance.manageCategories': 'Kelola Kategori',
    'finance.addCategory': 'Tambah Kategori',
    'finance.categoryName': 'Nama Kategori',
    'finance.chooseEmoji': 'Pilih Emoji',
    'finance.chooseColor': 'Pilih Warna',
    'finance.customCategories': 'Kategori Kustom',
    'finance.noBudgets': 'Belum ada anggaran',
    'finance.setFirstBudget': 'Atur anggaran pertamamu untuk memantau pengeluaran',
    'finance.addFromTemplate': 'Tambah dari Template',
    'finance.lastMonth': 'Bulan Lalu',
    'finance.last30Days': '30 Hari Terakhir',
    'finance.thisYear': 'Tahun Ini',
    'finance.clearFilter': 'Hapus Filter',
    'finance.totalBalance': 'Total Saldo',
    'finance.totalIncome': 'Total Pemasukan',
    'finance.totalExpenses': 'Total Pengeluaran',
    'finance.totalSavings': 'Total Tabungan',
    'finance.savingsProgress': 'Progress Tabungan',
    'finance.addSavingsGoal': 'Tambah Target Tabungan',
    'finance.goalTitle': 'Judul Target',
    'finance.targetAmountId': 'Jumlah Target',
    'finance.currentAmountId': 'Jumlah Saat Ini',
    'finance.deadlineId': 'Tenggat Waktu',
    'finance.addMoney': 'Tambah Uang',
    'finance.recurringTitle': 'Judul',
    'finance.copyLastMonth': 'Salin Bulan Lalu',
    'finance.saveAsTemplate': 'Simpan sebagai Template',
    'finance.templateName': 'Nama Template',
    'finance.templateDescription': 'Deskripsi',
    'finance.applyTemplate': 'Terapkan Template',
    'finance.deleteTemplate': 'Hapus Template',
    'finance.budgetTemplates': 'Template Anggaran',
    'finance.customTemplatesId': 'Template Kustom',
    'finance.basicLiving': 'Hidup Sederhana',
    'finance.familyBudget': 'Anggaran Keluarga',
    'finance.studentLife': 'Kehidupan Mahasiswa',
    'finance.workingPro': 'Profesional Bekerja',
    'finance.savingsFocused': 'Fokus Menabung',
    'finance.receipts': 'Struk',
    'finance.addReceipt': 'Tambah Struk',
    'finance.attachReceipt': 'Lampirkan Struk (opsional)',
    'finance.transactionUpdated': 'Transaksi diperbarui',
    'finance.addNotes': 'Tambah catatan...',
    
    // Expense logging (AI Assistant wallet integration)
    'expense.logExpense': 'Catat Pengeluaran',
    'expense.confirmDetails': 'Konfirmasi detail pengeluaran sebelum menyimpan',
    'expense.wallet': 'Dompet',
    'expense.loadingWallets': 'Memuat dompet...',
    'expense.noWallets': 'Tidak ada dompet. Buat dompet di Expense Tracker.',
    'expense.selectWallet': 'Pilih dompet',
    'expense.noWalletOption': 'Tanpa dompet',
    'expense.currentBalance': 'Saldo saat ini:',
    'expense.deduction': 'Pengeluaran:',
    'expense.newBalance': 'Saldo baru:',
    'expense.negativeWarning': 'Saldo akan menjadi negatif',
    'expense.confirmAndSave': 'Konfirmasi & Simpan',
    
    // Finance categories
    'finance.cat.food': 'Makanan',
    'finance.cat.groceries': 'Belanja Dapur',
    'finance.cat.transport': 'Transportasi',
    'finance.cat.shopping': 'Belanja',
    'finance.cat.bills': 'Tagihan',
    'finance.cat.utilities': 'Utilitas',
    'finance.cat.entertainment': 'Hiburan',
    'finance.cat.healthcare': 'Kesehatan',
    'finance.cat.education': 'Pendidikan',
    'finance.cat.subscriptions': 'Langganan',
    'finance.cat.travel': 'Perjalanan',
    'finance.cat.salary': 'Gaji',
    'finance.cat.investment': 'Investasi',
    'finance.cat.other': 'Lainnya',
    // Payment methods
    'finance.pay.cash': 'Tunai',
    'finance.pay.debit': 'Kartu Debit',
    'finance.pay.credit': 'Kartu Kredit',
    'finance.pay.transfer': 'Transfer Bank',
    'finance.pay.ewallet': 'Dompet Digital',
    'finance.pay.qris': 'QRIS',
    // Finance - Quick Add & Settings
    'finance.quickAddExpense': 'Tambah Cepat Pengeluaran',
    'finance.customize': 'Kustomisasi',
    'finance.showHide': 'Tampilkan / Sembunyikan',
    'finance.customQuickExpenses': 'Pengeluaran Cepat Kustom',
    'finance.addNewQuickExpense': 'Tambah Pengeluaran Cepat Baru',
    'finance.yourCustomQuickExpenses': 'Pengeluaran Cepat Kustommu',
    'finance.noCustomQuickExpenses': 'Belum ada pengeluaran cepat kustom. Tambahkan pengeluaran yang sering kamu gunakan di atas!',
    'finance.addQuickExpense': 'Tambah Pengeluaran Cepat',
    'finance.label': 'Label',
    'finance.incomeVsExpenses': 'Pemasukan vs Pengeluaran',
    'finance.currencySettings': 'Pengaturan Mata Uang',
    'finance.defaultCurrency': 'Mata Uang Default',
    'finance.showCurrencyConversion': 'Tampilkan Konversi Mata Uang',
    'finance.displayConvertedAmounts': 'Tampilkan jumlah yang dikonversi',
    'finance.convertTo': 'Konversi ke',
    'finance.settings': 'Pengaturan',
    'finance.enableQuickAdd': 'Aktifkan Tambah Cepat',
    'finance.quickAddDescription': 'Fitur ini opsional. Menonaktifkannya akan menyederhanakan halaman keuanganmu tanpa mempengaruhi data.',
    'finance.on': 'Aktif',
    'finance.off': 'Nonaktif',
    'finance.generateReport': 'Buat Laporan',
    'finance.downloadPdf': 'Unduh PDF',
    'finance.shareReport': 'Bagikan Laporan',
    'finance.history': 'Riwayat',
    'finance.todaySummary': 'Ringkasan Hari Ini',
    'finance.incomeToday': 'Pemasukan Hari Ini',
    'finance.expensesToday': 'Pengeluaran Hari Ini',
    'finance.netToday': 'Selisih Hari Ini',
    
    // Monthly Bills
    'finance.bills': 'Tagihan',
    'finance.monthlyBills': 'Checklist Tagihan Bulanan',
    'finance.addBill': 'Tambah Tagihan',
    'finance.editBill': 'Edit Tagihan',
    'finance.billName': 'Nama Tagihan',
    'finance.monthlyAmount': 'Jumlah Bulanan',
    'finance.dueDate': 'Tanggal Jatuh Tempo',
    'finance.optional': 'opsional',
    'finance.selectDueDate': 'Pilih tanggal jatuh tempo',
    'finance.totalAnnual': 'Total Tahunan',
    'finance.totalPaid': 'Total Dibayar',
    'finance.totalUnpaid': 'Belum Dibayar',
    'finance.overallProgress': 'Progress Keseluruhan',
    'finance.categoryBreakdown': 'Pengeluaran per Kategori',
    'finance.noBills': 'Belum ada tagihan',
    'finance.noBillsHint': 'Lacak tagihan bulanan seperti SPP sekolah, langganan, dan utilitas',
    'finance.addFirstBill': 'Tambah Tagihan Pertama',
    'finance.monthsPaid': 'bulan dibayar',
    'finance.monthsLeft': 'tersisa',
    'finance.noFilteredBills': 'Tidak ada tagihan di kategori ini',
    'finance.noFilteredBillsHint': 'Coba pilih kategori lain atau tambahkan tagihan baru',
    'finance.showAllBills': 'Tampilkan Semua Tagihan',
    
    // Personal Loans
    'finance.loans': 'Pinjaman',
    'finance.loans.title': 'Pinjaman Pribadi',
    'finance.loans.addLoan': 'Tambah Pinjaman',
    'finance.loans.editLoan': 'Edit Pinjaman',
    'finance.loans.loanName': 'Nama Pinjaman',
    'finance.loans.loanNamePlaceholder': 'contoh: Kredit Mobil, Renovasi Rumah',
    'finance.loans.totalAmount': 'Jumlah Total',
    'finance.loans.remaining': 'Sisa',
    'finance.loans.monthlyPayment': 'Cicilan Bulanan',
    'finance.loans.dueDay': 'Tanggal Jatuh Tempo (1-31)',
    'finance.loans.status': 'Status',
    'finance.loans.active': 'Aktif',
    'finance.loans.paidOff': 'Lunas',
    'finance.loans.notes': 'Catatan (opsional)',
    'finance.loans.notesPlaceholder': 'Detail tambahan...',
    'finance.loans.saveChanges': 'Simpan Perubahan',
    'finance.loans.disbursementSection': 'Dana Diterima (Opsional)',
    'finance.loans.disbursementHelp': 'Catat dana yang benar-benar Anda terima ke dompet. Ini mungkin berbeda dari pokok pinjaman.',
    'finance.loans.amountReceived': 'Jumlah Diterima',
    'finance.loans.receiveToWallet': 'Terima ke Dompet',
    'finance.loans.selectWallet': 'Pilih dompet',
    'finance.loans.noWallet': 'Tidak ada dompet dipilih',
    'finance.loans.disbursement': 'Pencairan Pinjaman',
    'finance.loans.description': 'Lacak pinjaman pribadi Anda dengan tenang dan sederhana. Ini hanya untuk pelacakan pribadi.',
    'finance.loans.totalRemaining': 'Total Sisa',
    'finance.loans.monthlyPayments': 'Cicilan Bulanan',
    'finance.loans.recordPayment': 'Catat Pembayaran',
    'finance.loans.paymentAmount': 'Jumlah Pembayaran',
    'finance.loans.paymentDate': 'Tanggal Pembayaran',
    'finance.loans.paymentNotes': 'Catatan (opsional)',
    'finance.loans.paymentNotesPlaceholder': 'contoh: Cicilan bulanan, Bayar ekstra',
    'finance.loans.paidFromWallet': 'Dibayar dari dompet',
    'finance.loans.selectWalletRequired': 'Harap pilih dompet untuk pembayaran ini',
    'finance.loans.progress': 'Progress',
    'finance.loans.paid': 'dibayar',
    'finance.loans.paymentHistory': 'Riwayat Pembayaran',
    'finance.loans.noLoans': 'Belum ada pinjaman',
    'finance.loans.noLoansHint': 'Lacak pinjaman pribadi Anda di sini',
    'finance.loans.congratulations': '🎉 Selamat! Pinjaman lunas!',
    'finance.loans.paymentRecorded': 'Pembayaran berhasil dicatat',
    'finance.loans.loanAdded': 'Pinjaman ditambahkan',
    'finance.loans.loanUpdated': 'Pinjaman diperbarui',
    'finance.loans.loanDeleted': 'Pinjaman dihapus',
    'finance.loans.paymentDeleted': 'Pembayaran dihapus',
    'finance.selectDay': 'Pilih hari',
    'finance.noSpecificDay': 'Tidak ada hari tertentu',
    
    // Category Preferences
    'categoryPrefs.title': 'Preferensi Kategori',
    'categoryPrefs.description': 'Tampilkan atau sembunyikan kategori untuk personalisasi',
    'categoryPrefs.home': 'Rumah',
    'categoryPrefs.work': 'Kerja',
    'categoryPrefs.money': 'Keuangan',
    'categoryPrefs.self': 'Diri Sendiri',
    'categoryPrefs.kids': 'Anak',
    'categoryPrefs.homeDesc': 'Tugas rumah tangga dan manajemen rumah',
    'categoryPrefs.workDesc': 'Tugas profesional dan karier',
    'categoryPrefs.moneyDesc': 'Manajemen keuangan dan anggaran',
    'categoryPrefs.selfDesc': 'Kesehatan dan perawatan diri',
    'categoryPrefs.kidsDesc': 'Parenting dan aktivitas anak',
    
    // Tasks
    'tasks.title': 'Tugas Saya',
    'tasks.addTask': 'Tambah Tugas',
    'tasks.quickAdd': 'Tambah tugas cepat...',
    'tasks.focusToday': 'Fokus Hari Ini',
    'tasks.allTasks': 'Semua Tugas',
    'tasks.completed': 'Selesai',
    'tasks.priority': 'Prioritas',
    'tasks.deadline': 'Tenggat',
    'tasks.area': 'Area',
    'tasks.delegateTo': 'Delegasikan ke',
    'tasks.notes': 'Catatan',
    'tasks.recurring': 'Berulang',
    'tasks.reminder': 'Pengingat',
    'tasks.noTasks': 'Belum ada tugas',
    'tasks.addFirstTask': 'Tambahkan tugas pertama untuk memulai',
    'tasks.today': 'Hari Ini',
    'tasks.tomorrow': 'Besok',
    'tasks.overdue': 'Terlambat',
    'tasks.listView': 'Daftar',
    'tasks.weekView': 'Minggu',
    'tasks.unscheduled': 'Belum Dijadwalkan',
    'tasks.high': 'Tinggi',
    'tasks.medium': 'Sedang',
    'tasks.low': 'Rendah',
    'tasks.home': 'Rumah',
    'tasks.kids': 'Anak',
    'tasks.work': 'Kerja',
    'tasks.money': 'Keuangan',
    'tasks.self': 'Diri Sendiri',
    'tasks.templates': 'Template',
    
    // Shopping
    'shopping.title': 'Daftar Belanja',
    'shopping.addItem': 'Tambah Barang',
    'shopping.quickAdd': 'Tambah cepat...',
    'shopping.daily': 'Harian',
    'shopping.weekly': 'Mingguan',
    'shopping.monthly': 'Bulanan',
    'shopping.pantry': 'Dapur',
    'shopping.category': 'Kategori',
    'shopping.quantity': 'Jumlah',
    'shopping.unit': 'Satuan',
    'shopping.price': 'Harga',
    'shopping.noItems': 'Belum ada barang',
    'shopping.addFirstItem': 'Tambahkan barang pertama',
    'shopping.clearCompleted': 'Hapus yang selesai',
    'shopping.total': 'Total',
    'shopping.items': 'barang',
    'shopping.share': 'Bagikan Daftar',
    'shopping.templates': 'Template',
    'shopping.saveTemplate': 'Simpan sebagai Template',
    'shopping.loadTemplate': 'Muat Template',
    'shopping.quickItems': 'Tambah Cepat',
    'shopping.editQuickItems': 'Edit Item Cepat',
    'shopping.fresh': 'Segar',
    'shopping.cleaning': 'Kebersihan',
    'shopping.household': 'Rumah Tangga',
    'shopping.personal': 'Perawatan Diri',
    'shopping.snacks': 'Cemilan',
    'shopping.drinks': 'Minuman',
    'shopping.other': 'Lainnya',
    
    // Self-Care
    'selfcare.title': 'Ruang Perawatan Diri',
    'selfcare.subtitle': 'Ruang tenang untukmu 💜',
    'selfcare.signInPrompt': 'Silakan masuk untuk mengakses ruang perawatan diri Anda.',
    'selfcare.calmMode': 'Mode tenang',
    'selfcare.normal': 'Normal',
    'selfcare.footerMessage': 'Ingat: tidak ada cara sempurna untuk merawat diri sendiri.',
    'selfcare.footerMessage2': 'Yang penting adalah kamu mencoba. 🌱',
    'selfcare.howFeeling': 'Bagaimana perasaanmu hari ini?',
    'selfcare.shareThought': 'Atau bagikan pikiranmu... (opsional)',
    'selfcare.updateCheckin': 'Perbarui Check-in',
    'selfcare.saveCheckin': 'Simpan Check-in',
    'selfcare.alreadyCheckedIn': 'Kamu sudah check-in hari ini ✓',
    'selfcare.thankYouCheckin': 'Terima kasih sudah check-in 💜',
    'selfcare.energyCheck': 'Cek Energi',
    'selfcare.optional': '(opsional)',
    'selfcare.tired': 'Lelah',
    'selfcare.okay': 'Biasa',
    'selfcare.calm': 'Tenang',
    'selfcare.overwhelmed': 'Kewalahan',
    'selfcare.moodLogged': 'Mood tercatat 💜',
    'selfcare.sleepLog': 'Catatan Tidur',
    'selfcare.howDidYouSleep': 'Bagaimana tidurmu semalam?',
    'selfcare.poor': 'Buruk',
    'selfcare.fair': 'Cukup',
    'selfcare.good': 'Baik',
    'selfcare.great': 'Sangat Baik',
    'selfcare.loggedForToday': 'Tercatat untuk hari ini',
    'selfcare.sleepLogged': 'Tidur tercatat 🌙',
    'selfcare.breathingExercise': 'Latihan Pernapasan',
    'selfcare.breatheIn': 'Tarik napas...',
    'selfcare.hold': 'Tahan...',
    'selfcare.breatheOut': 'Hembuskan...',
    'selfcare.rest': 'Istirahat...',
    'selfcare.cycle': 'siklus',
    'selfcare.cycles': 'siklus',
    'selfcare.takeAMoment': 'Luangkan waktu untuk bernapas',
    'selfcare.start': 'Mulai',
    'selfcare.pause': 'Jeda',
    'selfcare.breathingTip': '4 detik masuk · 4 detik tahan · 6 detik keluar',
    'selfcare.gentleHabits': 'Kebiasaan Baik',
    'selfcare.beginAgain': 'Kamu selalu bisa memulai lagi 💜',
    'selfcare.noHabits': 'Belum ada kebiasaan. Tambahkan saat kamu siap.',
    'selfcare.addGentleHabit': 'Tambah Kebiasaan Baik',
    'selfcare.addHabit': 'Tambah Kebiasaan',
    'selfcare.habitAdded': 'Kebiasaan ditambahkan 🌱',
    'selfcare.habitRemoved': 'Kebiasaan dihapus',
    'selfcare.day': 'hari',
    'selfcare.days': 'hari',
    'selfcare.completed': 'selesai',
    'selfcare.restCategory': 'Istirahat',
    'selfcare.movement': 'Gerakan',
    'selfcare.reflection': 'Refleksi',
    'selfcare.gratitudeJournal': 'Jurnal Syukur',
    'selfcare.whatGrateful': 'Apa yang kamu syukuri hari ini?',
    'selfcare.tapToAdd': 'Ketuk untuk menambah syukur pertamamu',
    'selfcare.imGratefulFor': 'Aku bersyukur untuk...',
    'selfcare.gratitudeSaved': 'Syukur tersimpan 🌸',
    'selfcare.gratitudesAdded': 'Kamu sudah menambah 3 syukur untuk hari ini 💜',
    'selfcare.ofGratitudes': 'dari',
    'selfcare.gratitudesToday': 'syukur hari ini',
    'selfcare.completedGratitude': '✓ Kamu sudah menyelesaikan latihan syukur hari ini',
    'selfcare.weeklyWellness': 'Kesehatan Mingguan',
    'selfcare.weeklySnapshot': 'Ringkasan perawatan diri 7 hari terakhir',
    'selfcare.doingAmazing': 'Kamu luar biasa! 🌟',
    'selfcare.goodProgress': 'Progres bagus minggu ini!',
    'selfcare.keepGoing': 'Terus semangat, kamu pasti bisa!',
    'selfcare.smallSteps': 'Langkah kecil juga berarti 💜',
    'selfcare.avgSleep': 'Rata-rata Tidur',
    'selfcare.topMood': 'Mood Utama',
    'selfcare.habitsDone': 'Kebiasaan Selesai',
    'selfcare.activeDays': 'Aktif',
    'selfcare.of7Days': 'dari 7 hari',
    'selfcare.startLogging': 'Mulai catat untuk melihat ringkasan kesehatanmu!',
    'selfcare.morningRoutine': 'Rutinitas Pagiku',
    'selfcare.wakeUpAt': 'Bangun jam',
    'selfcare.dailyAffirmation': 'Afirmasi harian',
    'selfcare.firstActivity': 'Aktivitas pertama',
    'selfcare.createMorningRoutine': 'Buat Rutinitas Pagi',
    'selfcare.setupGentleFlow': 'Atur rutinitas lembut untuk memulai hari dengan niat',
    'selfcare.getStarted': 'Mulai',
    'selfcare.morningRoutineSetup': 'Pengaturan Rutinitas Pagi',
    'selfcare.wakeUpTime': 'Waktu Bangun',
    'selfcare.whenStartDay': 'Jam berapa kamu ingin memulai hari?',
    'selfcare.morningAffirmation': 'Afirmasi Pagi',
    'selfcare.setIntention': 'Tetapkan niatmu untuk hari ini',
    'selfcare.firstSelfCareActivity': 'Aktivitas Perawatan Diri Pertama',
    'selfcare.chooseNurture': 'Pilih cara merawat dirimu di pagi hari',
    'selfcare.writeOwnOrChoose': 'Tulis sendiri atau pilih di bawah...',
    'selfcare.routineSaved': 'Rutinitas pagi tersimpan! Selamat pagi ✨',
    'selfcare.routineDeleted': 'Rutinitas dihapus',
    'selfcare.failedSaveRoutine': 'Gagal menyimpan rutinitas',
    'selfcare.failedDeleteRoutine': 'Gagal menghapus rutinitas',
    'selfcare.signInToSave': 'Silakan masuk untuk menyimpan rutinitas',
    'selfcare.saving': 'Menyimpan...',
    'selfcare.complete': 'Selesai',
    'selfcare.next': 'Lanjut',
    'selfcare.meditation': 'Meditasi 5 menit',
    'selfcare.morningStretches': 'Peregangan Pagi',
    'selfcare.gratitudeJournaling': 'Jurnal Syukur',
    'selfcare.deepBreathing': 'Napas Dalam',
    'selfcare.drinkWater': 'Minum Air',
    'selfcare.getSunlight': 'Berjemur',
    'selfcare.affirmation1': 'Hari ini aku memilih sukacita dan syukur',
    'selfcare.affirmation2': 'Aku mampu melakukan hal-hal luar biasa',
    'selfcare.affirmation3': 'Aku layak mendapat kedamaian dan kebahagiaan',
    'selfcare.affirmation4': 'Aku percaya perjalanan hidupku',
    'selfcare.affirmation5': 'Aku cukup, apa adanya',
    
    // Reminders
    'reminder.title': 'Pengingat',
    'reminder.placeholder': 'Judul pengingat',
    'reminder.add': 'Tambah',
    'reminder.noReminders': 'Belum ada pengingat',
    'reminder.fired': 'Terkirim',
    'reminder.added': 'Pengingat ditambahkan!',
    'reminder.removed': 'Pengingat dihapus',
    'reminder.fillTitleTime': 'Mohon isi judul dan waktu',
    
    // Common
    'common.back': 'Kembali',
    'common.save': 'Simpan',
    'common.cancel': 'Batal',
    'common.delete': 'Hapus',
    'common.edit': 'Ubah',
    'common.loading': 'Memuat...',
    'common.add': 'Tambah',
    'common.close': 'Tutup',
    'common.confirm': 'Konfirmasi',
    'common.all': 'Semua',
    'common.success': 'Berhasil',
    'common.error': 'Error',
    'common.update': 'Perbarui',
    'common.submit': 'Kirim',
    
    // Toast messages - Tasks
    'toast.taskAdded': 'Tugas ditambahkan!',
    'toast.taskUpdated': 'Tugas diperbarui!',
    'toast.taskDeleted': 'Tugas dihapus',
    'toast.taskCompleted': 'Tugas selesai! Tugas berikutnya dibuat.',
    'toast.maxFocusTasks': 'Maksimal 3 tugas fokus dalam satu waktu',
    'toast.templateTasksAdded': 'tugas dari template ditambahkan',
    'toast.taskRescheduled': 'Tugas dijadwalkan ulang',
    'toast.errorFetchingTasks': 'Gagal memuat tugas',
    'toast.errorAddingTask': 'Gagal menambah tugas',
    'toast.errorUpdatingTask': 'Gagal memperbarui tugas',
    'toast.errorDeletingTask': 'Gagal menghapus tugas',
    
    // Toast messages - Shopping
    'toast.itemAdded': 'Barang ditambahkan!',
    'toast.itemDeleted': 'Barang dihapus',
    'toast.itemsCleared': 'Barang dihapus',
    'toast.templateSaved': 'Template tersimpan!',
    'toast.templateLoaded': 'Template dimuat!',
    'toast.templateDeleted': 'Template dihapus',
    'toast.linkCopied': 'Link disalin!',
    'toast.errorFetchingItems': 'Gagal memuat barang',
    'toast.errorAddingItem': 'Gagal menambah barang',
    'toast.errorDeletingItem': 'Gagal menghapus barang',
    
    // Toast messages - Finance
    'toast.transactionAdded': 'Transaksi ditambahkan!',
    'toast.transactionDeleted': 'Transaksi dihapus',
    'toast.budgetSet': 'Anggaran ditetapkan!',
    'toast.budgetUpdated': 'Anggaran diperbarui!',
    'toast.budgetDeleted': 'Anggaran dihapus',
    'toast.categoryCreated': 'Kategori dibuat!',
    'toast.categoryDeleted': 'Kategori dihapus',
    'toast.savingsGoalCreated': 'Target tabungan dibuat!',
    'toast.savingsGoalDeleted': 'Target tabungan dihapus',
    'toast.recurringAdded': 'Transaksi berulang ditambahkan!',
    'toast.dataRefreshed': 'Data diperbarui!',
    'toast.errorFetchingExpenses': 'Gagal memuat pengeluaran',
    'toast.errorAddingExpense': 'Gagal menambah pengeluaran',
    'toast.noLastMonthBudgets': 'Tidak ada anggaran bulan lalu',
    
    // Additional Tasks translations
    'tasks.oneStep': 'Satu langkah pada satu waktu. Kamu pasti bisa!',
    'tasks.addWithDetails': 'Tambah dengan detail',
    'tasks.removeFromFocus': 'Hapus dari fokus',
    'tasks.addToFocus': 'Jadikan fokus hari ini',
    'tasks.editTask': 'Edit tugas',
    'tasks.deleteTask': 'Hapus tugas',
    'tasks.undo': 'Batalkan',
    'tasks.atDeadline': 'Saat tenggat waktu',
    'tasks.15min': '15 menit sebelumnya',
    'tasks.30min': '30 menit sebelumnya',
    'tasks.1hour': '1 jam sebelumnya',
    'tasks.2hours': '2 jam sebelumnya',
    'tasks.1day': '1 hari sebelumnya',
    'tasks.none': 'Tidak ada',
    'tasks.subtasks': 'Sub-tugas',
    'tasks.addSubtask': 'Tambah sub-tugas',
    'tasks.saveTemplate': 'Simpan sebagai Template',
    'tasks.noRecurring': 'Tidak berulang',
    
    // Additional Shopping translations
    'shopping.organizeStressFree': 'Atur belanjamu, tanpa stres 🛒',
    'shopping.needToBuy': 'Perlu dibeli',
    'shopping.bought': 'Sudah dibeli',
    'shopping.copyToDaily': 'Salin ke Harian',
    'shopping.clearAll': 'Hapus semua',
    'shopping.inStock': 'Tersedia',
    'shopping.lowStock': 'Menipis',
    'shopping.outOfStock': 'Habis',
    'shopping.itemName': 'Nama barang',
    'shopping.createShareLink': 'Buat Link Berbagi',
    'shopping.shareableLink': 'Link Berbagi',
    'shopping.copyLink': 'Salin Link',
    'shopping.deleteTemplate': 'Hapus Template',
    'shopping.noTemplates': 'Belum ada template',
    
    // Additional Finance translations
    'finance.manageFinances': 'Kelola keuanganmu dengan bijak',
    'finance.insights': 'Analisa AI',
    'finance.report': 'Laporan Bulanan',
    'finance.noData': 'Belum ada data',
    'finance.addFirstTransaction': 'Tambahkan transaksi pertamamu untuk memulai',
    'finance.expenseType': 'Pengeluaran',
    'finance.incomeType': 'Pemasukan',
    'finance.savingType': 'Tabungan',
    'finance.cash': 'Tunai',
    'finance.bankTransfer': 'Transfer Bank',
    'finance.creditCard': 'Kartu Kredit',
    'finance.eWallet': 'E-Wallet',
    'finance.addToGoal': 'Tambah ke Target',
    'finance.targetAmount': 'Target Jumlah',
    'finance.currentAmount': 'Jumlah Saat Ini',
    'finance.progress': 'Progres',
    'finance.copyFromLastMonth': 'Salin dari Bulan Lalu',
    'finance.noSavingsGoals': 'Belum ada target tabungan',
    'finance.createFirstGoal': 'Buat target tabungan pertamamu',
    'finance.savings.amountToAdd': 'Jumlah Ditambahkan',
    'finance.savings.fromWallet': 'Dari dompet',
    'finance.savings.selectWallet': 'Pilih dompet',
    'finance.savings.selectWalletRequired': 'Harap pilih dompet untuk transfer ini',
    'finance.savings.addFunds': 'Tambah Dana',
    
    // Landing Page - Hero
    'landing.badge': 'Memberdayakan Ibu di Seluruh Dunia',
    'landing.headline': 'Kelola Rumahmu Seperti',
    'landing.headlineHighlight': 'CEO',
    'landing.subheadline': 'TechMom membantumu',
    'landing.thrive': 'berkembang',
    'landing.subheadlineEnd': ', bukan sekadar bertahan. Kelola keluarga, rumah, dan bisnis dari satu dashboard canggih.',
    'landing.startFree': 'Mulai Gratis Sekarang',
    'landing.seeHow': 'Lihat Cara Kerjanya',
    
    // Landing Page - Problem/Solution
    'landing.problemTitle': 'Terlalu Banyak yang Dikerjakan?',
    'landing.problemHighlight': 'Kami Mengerti.',
    'landing.problemDesc': 'Antara keluarga, rumah, dan pekerjaan, ibu modern melakukan semuanya. TechMom menyatukan semua dalam satu dashboard yang indah dan cerdas.',
    'landing.smartTasks': 'Tugas Cerdas',
    'landing.smartTasksDesc': 'Tidak pernah melewatkan tenggat waktu dengan prioritas tugas berbasis AI',
    'landing.financeTracker': 'Pencatat Keuangan',
    'landing.financeTrackerDesc': 'Lacak pengeluaran keluarga dan hemat uang dengan mudah',
    'landing.menuPlanner': 'Perencana Menu',
    'landing.menuPlannerDesc': 'Rencanakan menu dan buat daftar belanja secara otomatis',
    'landing.familyCalendar': 'Kalender Keluarga',
    'landing.familyCalendarDesc': 'Koordinasi jadwal dan delegasikan tugas dengan lancar',
    'landing.selfCareGoals': 'Tujuan Perawatan Diri',
    'landing.selfCareGoalsDesc': 'Prioritaskan dirimu dengan pengingat lembut dan pelacakan',
    'landing.aiAssistant': 'Asisten AI',
    'landing.aiAssistantDesc': 'Dapatkan saran personal, ide menu, tips keuangan, dan dukungan motivasi dari asisten cerdasmu yang memahami kebutuhan unik keluargamu.',
    
    // Landing Page - App Preview
    'landing.previewTitle': 'Desain Cantik,',
    'landing.previewHighlight': 'Fitur Handal',
    'landing.previewDesc': 'Akses dashboard-mu di mana saja — di ponsel, tablet, atau desktop. Semua tersinkronisasi secara real-time.',
    'landing.mobile': 'Ponsel',
    'landing.tablet': 'Tablet',
    'landing.desktop': 'Desktop',
    'landing.realtimeSync': 'Sinkronisasi Real-time',
    'landing.realtimeSyncDesc': 'Perubahan diperbarui langsung di semua perangkat',
    'landing.offlineMode': 'Mode Offline',
    'landing.offlineModeDesc': 'Tetap bekerja meski tanpa internet',
    'landing.securePrivate': 'Aman & Privat',
    'landing.securePrivateDesc': 'Data keluargamu terenkripsi dan aman',
    
    // Landing Page - Testimonials
    
    // Landing Page - Final CTA
    'landing.ctaTitle': 'Siap mengendalikan harimu?',
    'landing.ctaDesc': 'Satukan rumah, keuangan, bisnis, dan kesejahteraanmu dalam satu tempat yang tenang.',
    
    // Landing Page - Footer
    'landing.footerDesc': 'Memberdayakan ibu untuk mengelola keluarga, rumah, dan bisnis dari satu dashboard — dengan AI, komunitas, dan keseimbangan.',
    'landing.product': 'Produk',
    'landing.features': 'Fitur',
    'landing.pricing': 'Harga',
    'landing.faq': 'FAQ',
    'landing.company': 'Perusahaan',
    'landing.about': 'Tentang',
    'landing.contact': 'Kontak',
    'landing.blog': 'Blog',
    'landing.privacyPolicy': 'Kebijakan Privasi',
    'landing.termsOfService': 'Syarat Layanan',
    'landing.copyright': '© 2025 TechMom v1.0 (Beta). Dibuat dengan',
    'landing.forMoms': 'untuk ibu di mana saja.',
    'landing.terms': 'Syarat',
    'landing.privacy': 'Privasi',
    'landing.cookies': 'Cookie',

    // Landing Page — Refined (2026)
    'landing.heroBadge': 'Satu dashboard untuk seluruh hidupmu',
    'landing.heroHeadline': 'Kelola Hidupmu Seperti',
    'landing.heroHeadlineHighlight': 'CEO.',
    'landing.heroSubheadline': 'TechMom membantu ibu mengelola keluarga, rumah, uang, dan bisnis dari satu dashboard sederhana.',
    'landing.featuresSectionTitle': 'Yang TechMom bantu kamu kelola',
    'landing.featuresSectionDesc': 'Setiap bagian harimu, dalam satu tempat yang tenang.',
    'landing.featGroupHome': 'Rumah',
    'landing.featGroupMoney': 'Keuangan',
    'landing.featGroupBusiness': 'Bisnis',
    'landing.featGroupYou': 'Dirimu',
    'landing.featGroupSmart': 'Dukungan Pintar',
    'landing.featDailyRoutine': 'Rutinitas Harian',
    'landing.featMenu': 'Perencana Menu',
    'landing.featShopping': 'Daftar Belanja',
    'landing.featTasks': 'Tugas',
    'landing.featExpense': 'Pencatat Pengeluaran',
    'landing.featWallet': 'Dompet',
    'landing.featSavings': 'Tabungan & perencanaan',
    'landing.featBusiness': 'Pusat Bisnis',
    'landing.featSelfCare': 'Perawatan Diri',
    'landing.featMovement': 'Gerakan',
    'landing.featJournal': 'Jurnal',
    'landing.featAI': 'Asisten AI',
    'landing.featReminders': 'Pengingat',
    'landing.featCommunity': 'Komunitas',
    'landing.simpleTitle': 'Semua yang penting. Dalam satu tempat.',
    'landing.simpleDesc': 'Dari rutinitas harian keluarga hingga uang, bisnis, dan tujuan pribadimu — TechMom menyatukan semuanya agar kamu lebih sedikit mengurus kehidupan dan lebih banyak menjalaninya.',
    'landing.howTitle': 'Cara kerjanya',
    'landing.howStep1Title': 'Atur',
    'landing.howStep1Desc': 'Bawa kehidupan harianmu ke satu dashboard.',
    'landing.howStep2Title': 'Kelola',
    'landing.howStep2Desc': 'Lacak tugas, uang, rutinitas, dan bisnismu.',
    'landing.howStep3Title': 'Tumbuh',
    'landing.howStep3Desc': 'Gunakan waktu dan uangmu dengan lebih sengaja.',
    'landing.trustTitle': 'Dibuat oleh seorang ibu, untuk ibu.',
    'landing.trustDesc': 'TechMom dirancang berdasarkan kenyataan sehari-hari mengelola rumah, keluarga, dan kehidupan — tanpa tekanan maupun kebisingan.',
    'landing.ctaButton': 'Mulai Gratis',
    'landing.ctaNote': 'Tidak perlu kartu kredit untuk memulai.',

    // Premium section
    'landing.premiumBadge': 'TechMom Premium',
    'landing.premiumTitle': 'TechMom Premium',
    'landing.premiumDesc': 'Buka fitur yang membantu mengelola keuangan, bisnis, dan kesejahteraanmu dengan lebih tenang.',
    'landing.premiumFeatureFinance': 'Keuangan — penuh pemasukan, pengeluaran, anggaran, dan dompet',
    'landing.premiumFeatureBusiness': 'Business Hub — kelola toko dan produkmu',
    'landing.premiumFeatureAI': 'Asisten AI — catat pengeluaran dan minta bantuan via chat',
    'landing.premiumFeatureJournal': 'Jurnal — ruang tenang untuk merenung dan menulis',
    'landing.premiumFeatureSelfCare': 'Self-Care — cek-in lembut dan mode tenang',
    'landing.premiumFeatureMovement': 'Movement — pelacakan aktivitas ringan',
    'landing.premiumButton': 'Upgrade ke Premium',
    'landing.premiumNote': 'Pembayaran sekali bayar untuk 30 hari, tanpa perpanjangan otomatis. Pembayaran diproses secara aman oleh Duitku.',
    'premium.starting': 'Membuka pembayaran aman...',
    'premium.startError': 'Kami tidak dapat memulai pembayaran. Silakan coba lagi.',
    'premium.notConfigured': 'Pembayaran belum tersedia. Silakan coba lagi nanti.',
    'payment.successTitle': 'Pembayaran diterima',
    'payment.successDesc': 'Akses TechMom Premium kamu aktif untuk satu bulan ke depan. Selamat menikmati.',
    'payment.pendingTitle': 'Menunggu konfirmasi',
    'payment.pendingDesc': 'Kami sedang mengonfirmasi pembayaranmu. Halaman ini akan diperbarui otomatis.',
    'payment.failedTitle': 'Pembayaran belum selesai',
    'payment.failedDesc': 'Pembayaranmu dibatalkan atau tidak berhasil. Tidak ada biaya yang ditagih dan Premium tidak diaktifkan.',
    'payment.goDashboard': 'Ke dasbor',
    'payment.tryAgain': 'Coba lagi',
    'payment.cancelledNotice': 'Pembayaran dibatalkan atau belum selesai.',
    'payment.processingTitle': 'Pembayaran sedang diproses',
    'payment.checkStatus': 'Cek status',
    'payment.tryLater': 'Coba lagi sebentar',
    'payment.oneOffPeriod': 'Pembayaran sekali bayar untuk 30 hari, tanpa perpanjangan otomatis.',
    'payment.periodEnd': 'Akses saat ini berakhir',
    'payment.renew': 'Perpanjang',
    'payment.renewalNotice': 'Premium kamu berakhir pada [date]. Perpanjang?',

    // Contact section
    'landing.contactTitle': 'Kontak & Dukungan',
    'landing.contactDesc': 'Kami siap membantu. Hubungi kami kapan saja dan kami akan segera merespons.',
    'landing.contactEmailLabel': 'Email',
    'landing.contactWhatsAppLabel': 'WhatsApp',
    'landing.contactAddressLabel': 'Alamat bisnis',
    'landing.contactAddressValue': 'Jalan Glogor Carik Gang Ratna Indah No 8, Denpasar Selatan, Bali',

    // Journal
    'journal.title': 'Jurnal',
    'journal.subtitle': 'Ruang tenang untuk menulis, refleksi, dan bernapas.',
    'journal.emptyState': 'Belum ada catatan jurnal.',
    'journal.emptyStateHint': 'Mulai dengan satu pikiran kecil hari ini.',
    'journal.newEntry': 'Tulis Jurnal',
    'journal.newEntryTitle': 'Jurnal Baru',
    'journal.editEntry': 'Edit Jurnal',
    'journal.titleLabel': 'Judul (opsional)',
    'journal.titlePlaceholder': 'misalnya: Pikiran hari ini',
    'journal.dateLabel': 'Tanggal',
    'journal.contentPlaceholder': 'Tulis dengan bebas. Tidak ada aturan. Ini hanya untukmu.',
    'journal.save': 'Simpan Jurnal',
    'journal.cancel': 'Batal',
    'journal.untitled': 'Tanpa Judul',
    
    // Business Hub
    'business.title': 'Bisnis Saya',
    'business.quickAction': 'Aksi Cepat',
    'business.totalRevenue': 'Total Pendapatan',
    'business.invoices': 'Faktur',
    'business.customers': 'Pelanggan',
    'business.inventory': 'Inventaris',
    'business.orders': 'Pesanan',
    'business.paid': 'lunas',
    'business.backToOrders': 'Kembali ke Pesanan',
    'business.order': 'Pesanan',
    'business.due': 'Jatuh Tempo',
    'business.noOrders': 'Belum ada pesanan',
    'business.noInvoices': 'Belum ada faktur',
    'business.noCustomers': 'Belum ada pelanggan',
    'business.noInventory': 'Belum ada inventaris',
    'business.stock': 'Stok',
    
    // Marketplace additional
    'marketplace.viewCart': 'Lihat Keranjang',
    'marketplace.viewAll': 'Lihat semua',
    'marketplace.securePayment': 'Belanja Aman',
    'marketplace.momOwned': 'Bisnis Milik Ibu',
    'marketplace.qualityGuaranteed': 'Kualitas Terjamin',
    'marketplace.madeWithLove': 'Dibuat dengan cinta oleh ibu, untuk ibu',
    'marketplace.noProducts': 'Tidak ada produk',
    'marketplace.noProductsHint': 'Coba pencarian atau kategori lain',
    'marketplace.productDeleted': 'Produk dihapus',
    'marketplace.productRestored': 'Produk dikembalikan',
    'marketplace.shopDeleted': 'Toko dihapus',
    'marketplace.shopRestored': 'Toko dikembalikan',
    'marketplace.deleteError': 'Gagal menghapus',
    
    // AI Assistant
    'ai.title': 'Coach Keuangan AI',
    'ai.subtitle': 'Pendamping keuangan pribadimu',
    'ai.welcome': 'Hai!',
    'ai.welcomeDesc': 'Aku di sini untuk membantu keuangan dan kehidupanmu. Tanya apa saja, upload struk, atau pilih topik di bawah.',
    'ai.quickQuestions': 'Tanya Cepat',
    'ai.canIAfford': 'Bisakah aku beli ini?',
    'ai.analyzeWeek': 'Analisis mingguku',
    'ai.moneyLeaks': 'Uang bocor?',
    'ai.todaysFocus': 'Fokus hari ini',
    'ai.helpSave': 'Bantu menabung',
    'ai.analyzing': 'Menganalisis data keuanganmu...',
    'ai.uploadHint': 'Upload struk atau tagihan untuk bantuan mencatat',
    'ai.askPlaceholder': 'Tanya tentang keuanganmu...',
    'ai.loginFirst': 'Silakan masuk ke akunmu terlebih dahulu untuk menggunakan AI Money Coach.',
    'ai.error': 'Maaf, terjadi kesalahan. Coba lagi ya!',
    'ai.sessionExpired': 'Sesi habis',
    'ai.pleaseLoginAgain': 'Silakan masuk kembali ke akunmu.',
    'ai.tooManyRequests': 'Terlalu banyak permintaan',
    'ai.waitAndRetry': 'Tunggu sebentar lalu coba lagi.',
    'ai.invalidFile': 'File tidak valid',
    'ai.failedProcessImage': 'Gagal memproses gambar',
    'ai.tryAnotherImage': 'Coba lagi dengan gambar lain',
    
    // Unified AI Assistant
    'unifiedAi.title': 'TechMom AI',
    'unifiedAi.subtitle': 'Asisten hidupmu',
    'unifiedAi.welcome': 'Hai! Aku bisa bantu dengan pengeluaran, tugas, belanja, menu, dan self-care. Mau apa hari ini?',
    'unifiedAi.placeholder': 'Tanya apa saja...',
    'unifiedAi.pleaseLogin': 'Silakan masuk untuk menggunakan AI assistant.',
    'unifiedAi.noResponse': 'Tidak ada respons. Coba lagi.',
    'unifiedAi.error': 'Maaf, terjadi kesalahan. Coba lagi ya!',
    'unifiedAi.thinking': 'Berpikir...',
    'unifiedAi.logExpense': 'Catat pengeluaran',
    'unifiedAi.addTask': 'Tambah tugas',
    'unifiedAi.addShopping': 'Tambah belanja',
    'unifiedAi.planMeal': 'Rencana menu',
    'unifiedAi.logMood': 'Log mood',
    'unifiedAi.confirmAction': 'Konfirmasi Aksi',
    'unifiedAi.reviewBeforeConfirm': 'Periksa detail sebelum konfirmasi.',
    'unifiedAi.cancel': 'Batal',
    'unifiedAi.confirm': 'Konfirmasi',
    'unifiedAi.actionSuccess': 'Selesai!',
    'unifiedAi.actionFailed': 'Aksi gagal',
    'unifiedAi.actionCancelled': 'Aksi dibatalkan.',
    'unifiedAi.preview.addExpense': 'Tambah Pengeluaran',
    'unifiedAi.preview.addIncome': 'Tambah Pemasukan',
    'unifiedAi.preview.amount': 'Jumlah',
    'unifiedAi.preview.category': 'Kategori',
    'unifiedAi.preview.wallet': 'Dompet',
    'unifiedAi.preview.notes': 'Catatan',
    'unifiedAi.preview.createTask': 'Buat Tugas',
    'unifiedAi.preview.title': 'Judul',
    'unifiedAi.preview.priority': 'Prioritas',
    'unifiedAi.preview.deadline': 'Batas waktu',
    'unifiedAi.preview.area': 'Area',
    'unifiedAi.preview.completeTask': 'Selesaikan Tugas',
    'unifiedAi.preview.task': 'Tugas',
    'unifiedAi.preview.addShopping': 'Tambah ke List Belanja',
    'unifiedAi.preview.item': 'Item',
    'unifiedAi.preview.qty': 'Jumlah',
    'unifiedAi.preview.list': 'List',
    'unifiedAi.preview.planMeal': 'Rencana Menu',
    'unifiedAi.preview.meal': 'Menu',
    'unifiedAi.preview.day': 'Hari',
    'unifiedAi.preview.type': 'Waktu',
    'unifiedAi.preview.logMood': 'Log Mood',
    'unifiedAi.preview.mood': 'Mood',
    'unifiedAi.preview.logSleep': 'Log Tidur',
    'unifiedAi.preview.quality': 'Kualitas',
    'unifiedAi.preview.hours': 'Jam',
    'unifiedAi.preview.addGratitude': 'Tambah Gratitude',
    'unifiedAi.preview.logMovement': 'Log Gerakan',
    'unifiedAi.preview.activity': 'Aktivitas',
    'unifiedAi.preview.duration': 'Durasi',
    
    // Language
    'lang': 'id',
  },
};
